var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefinition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-setup-wizard",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    svg#freepik_stories-setup-wizard:not(.animated) .animable {\r\n      opacity: 0;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el1lsll3kmwto {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eli7qjw4zfcul {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elto67uhz7odd {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elaes5ule31u {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elua16slluv9 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el9wenqpclb6b {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elyv8g3br4gae {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elsrx5j6l95am {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eluoa8jfrw1bc {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el2i0r6wq2cs {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elksqh475cmg {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el48c902szbv8 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elj2fp6vvsb9 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el3hbv3jz3s45 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el26o6wrpd5go {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elnqs4t37y6mm {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elbl56cbuohyb {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #freepik--background-complete--inject-127 {\r\n      animation: 1.5s Infinite linear floating;\r\n      animation-delay: 0s;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elz4ymfld6u99 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elw1fk27704r {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elgjy6sxueqxr {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elc6js6ve7yl {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elxdsx9rw0jjp {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elvdo3cjki5ma {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elg0msxmvnjyr {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elvx4yl4n7w6m {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elendj9ym9syc {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elbv3uvzjqrya {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elqox7wqnrt5 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el6w7nl6xf6f7 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elmcbhid84chn {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eljb10deq6ti {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eln5vpuif9fbo {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elxm0a1zbsqnd {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el2hy9r7sbdx2 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eldybb0th8uc5 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elyb00t4hepy {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el9l3kt30tijv {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elscs0lkrefeo {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elpu2uyvtslc {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elf2isfpf6314 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elf8u4zlyf47 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elkxwyxoharl {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elyifmb815kt7 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el538twqgt0n7 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #ellpiz1eky01 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elh0v0zre9nj {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elq5ypkd4yp6 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el3993r9ymdv8 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el4v6ve697ah {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elkbjp1vpeg {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #ellilb2rauqaf {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elf5tt4nd8z8 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el2237amj8scr {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elnyv013bxvbr {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el8hragd3p6ls {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el7hms22h90v5 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elkpcct5fjgx9 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elv7tyu186cc {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elcumxgsiu4yj {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el7jsmtx0o5p7 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elj069nqqspq {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elyecxll35ufg {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el18fn1pnte2t {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elpcv5m8fu3jq {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elzlj5pbhbsaf {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eloxqp1qf79h {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #ell4r6l5rkjfi {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elppg62hq0c3e {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elxulq12rd8p {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elakgsjrmk3wu {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elpx5q105y5p {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elmwtk4m33eid {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elprgv1j1iqz {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elea5iu970d78 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elfjy48l12c2h {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el2my57ixddpj {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eluvaa4mz3t8n {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elcj5ershdypt {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el7vouto42err {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eley976x4n0qm {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elvtkh8xj4yrf {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elklbyui61kdk {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eli20vch2qqcd {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el8vnsoxzsp6d {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elb3zmgp2for4 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eldg37uegcgph {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el2dbdibo9e87 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elludi15ymk2 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el2ucnj96qck {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elvf9p9rmr19k {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elas5e2q3ja9 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el7nmaer26jhc {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elux2e4k4xhv {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elvm1ewxkdws {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el5pfzio7vidm {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elpqj2b5g7lee {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elnj6a31jk478 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elmlwyv0uzizf {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elribabm1n4o8 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eljub8bdu0z6e {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el6ni55zctib8 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elin0shcyxyt {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elvahipj2j2r {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elwkn00zzibms {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elfihh80au7bk {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elfdxbgtjytr6 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elfv4oq77ay44 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elrea895acuws {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elod2egh7je6r {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el6dbenfq08om {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elkzjd7hi3j {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el39aizipypdd {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elz0sr1hlpw7 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elr1lqs41ck3 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el889r2jhndz6 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el57w3f5wbxk {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elnma3f8crh0d {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elknju2ylwuz {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elnzrc3tstt9 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elcfy696xhjl {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elx2r66hki41 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elzmcap23785 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eltb7brxc5idp {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eldx5w872w6r {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eln8awv6zzps {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eln6xhx339e2o {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elzhwncmx0fu {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eljzq0t1wra9 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elgnskxt4fvxq {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elted2ve6f5un {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elwbykg1oxag {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elryykahgfju {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el8rmidq94er {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el0h3qsqglfzpb {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elht73ibjwvwc {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el2rqohazxjyj {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #freepik--Screen--inject-127 {\r\n      animation: 1.5s Infinite linear floating;\r\n      animation-delay: 0s;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #freepik--Floor--inject-127 {\r\n      animation: 1.5s Infinite linear heartbeat;\r\n      animation-delay: 0s;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elkrbl8m835ag {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elwalfjqufa1d {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elyqsjtjkj4i {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elfhnb0y5h47e {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elo3u5kylv7ol {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el90kt5d9bgfj {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elwl4dlfbew2 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eltinflkwg1c9 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elrd7cai65y8 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elt5s92lm9qmn {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eldw1qmdixshs {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elw4ae1cuo1rk {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elavfxjignmp {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elrn9ywro89hi {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elq80jqflfc {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elgnehyy0jqlf {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elrlxm9n2vdnk {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elo1h8pq01g9e {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el9nmxs81h9en {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elqzmwby2mlx9 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elsryuy4kz43i {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elb32osbup5bi {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elkv4s549bkfb {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elz8tk09pvzuj {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elanbyr8zpwnv {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elcunzvjdg7xs {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elz1o3lmn3aea {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elld6edcquvkd {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eluqzqnw964 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eluoe48ml5nu {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elw3ip8fqu4wq {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eltdgiwjwe5ap {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elc3su3lcywq {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eln50k9pcvbr {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el2k8sm0nqnq2 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elco10rvrlqqj {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #ell8usduz24pj {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elahvkuyblb34 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elwj240kbukrs {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el09xguk4k8ukx {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #ell1wfc21ead9 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el00rs1ku6r3gim {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elqsxqpjy5cp {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el1f65qm89qmd {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elfeh19bcywl {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elcjnr1wi4wo5 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eltietjbd7z5h {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eli7b338an51 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el0jiv7chvane8 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elmy0bts0oidq {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elwgp265rge58 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elaebws247t5r {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elaieii2lvlyj {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elcnc38xp2e7o {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elljng3l8zpg9 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elvdoei984zxo {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elygwj04zm7o {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elfqjwlmyvh0u {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eltb9kyy3yba {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elcy5krph6e7p {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elhvs00nsgidv {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eld4zcgwplczd {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el6bxs71zt7p2 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eluhfcvdc066d {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el596jp1cjhh {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elwh36wtdh4qh {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elvl7zc4bg8y {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eluwxhdhi3nsq {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elthgscx6ti59 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el18bmsgixahn {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elro2d00p492c {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el1asyrpk36yq {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elgpi56jhupdb {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elavfs7sch3tm {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elckzufmh6o9a {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el3xnbnvdv3v {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el8casuoj7a4a {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #eltqv8phfjx6 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elj7v4sksd1d {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elcqtsvs8bwcu {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elrq8y6pkz279 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elsibdv1djve {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #ely3xo3sub5nf {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el2jd3kyh2trz {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elzm2d1z8k6h {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #elnwpp6mg5m1 {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #el6z74jubneia {\r\n      animation: ;\r\n      animation-delay: ;\r\n    }\r\n\r\n    svg#freepik_stories-setup-wizard.animated #freepik--Character--inject-127 {\r\n      animation: 1.5s Infinite linear wind;\r\n      animation-delay: 0s;\r\n    }\r\n\r\n    @keyframes floating {\r\n      0% {\r\n        opacity: 1;\r\n        transform: translateY(0px);\r\n      }\r\n\r\n      50% {\r\n        transform: translateY(-10px);\r\n      }\r\n\r\n      100% {\r\n        opacity: 1;\r\n        transform: translateY(0px);\r\n      }\r\n    }\r\n\r\n    @keyframes heartbeat {\r\n      0% {\r\n        transform: scale(1);\r\n      }\r\n\r\n      10% {\r\n        transform: scale(1.1);\r\n      }\r\n\r\n      30% {\r\n        transform: scale(1);\r\n      }\r\n\r\n      40% {\r\n        transform: scale(1);\r\n      }\r\n\r\n      50% {\r\n        transform: scale(1.1);\r\n      }\r\n\r\n      60% {\r\n        transform: scale(1);\r\n      }\r\n\r\n      100% {\r\n        transform: scale(1);\r\n      }\r\n    }\r\n\r\n    @keyframes wind {\r\n      0% {\r\n        transform: rotate(0deg);\r\n      }\r\n\r\n      25% {\r\n        transform: rotate(1deg);\r\n      }\r\n\r\n      75% {\r\n        transform: rotate(-1deg);\r\n      }\r\n    }\r\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-127",
    className: "animable",
    style: {
      transformOrigin: "250.115px 223.67px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.79,392.65l13.36-.28,6.58-.11c2.19-.05,4.36,0,6.54-.06l-.44.45-.06-11.19.5.5L428,381.9c-4.41,0-8.82-.12-13.24-.17l.28-.27c0,1.83-.09,3.67-.14,5.54Zm0,0-.14-5.54c0-1.86-.11-3.75-.13-5.65v-.27h.27c4.42-.05,8.83-.16,13.24-.17l13.24-.06h.5v.5l0,11.19v.45h-.45c-2.23,0-4.47,0-6.69-.06l-6.66-.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "428.145px 387.03px"
    },
    id: "el1lsll3kmwto",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.56,406.76l13.36-.28,6.58-.11c2.19-.05,4.36,0,6.54-.06l-.44.45-.05-11.19.49.5L442.8,396c-4.41,0-8.82-.12-13.24-.17l.28-.27c0,1.83-.09,3.67-.13,5.54Zm0,0-.14-5.54c0-1.86-.11-3.75-.13-5.65v-.27h.27c4.42-.05,8.83-.16,13.24-.17l13.24-.06h.51v.5l-.05,11.19v.45H456c-2.23,0-4.46,0-6.69-.05l-6.66-.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "442.92px 401.14px"
    },
    id: "eli7qjw4zfcul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elto67uhz7odd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.02,
    y: 395.57,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "413.26px 401.165px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.24,127l13.35-.27,6.58-.12c2.19,0,4.37,0,6.55-.05l-.45.44,0-11.19.5.5-13.24-.06c-4.42,0-8.83-.11-13.24-.16l.27-.28c0,1.84-.09,3.68-.13,5.54Zm0,0-.15-5.53c0-1.87-.11-3.76-.13-5.66v-.27h.28c4.41,0,8.82-.16,13.24-.16l13.24-.07h.5v.5L339.16,127v.45h-.44c-2.23,0-4.47,0-6.7-.06l-6.66-.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "325.59px 121.38px"
    },
    id: "elaes5ule31u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,141.12l13.35-.27,6.58-.12c2.19,0,4.37,0,6.55,0l-.45.44L353,129.93l.5.5-13.24-.06c-4.41,0-8.83-.11-13.24-.16l.27-.28c0,1.84-.08,3.68-.13,5.54Zm0,0-.14-5.53c-.05-1.87-.12-3.76-.13-5.66v-.27H327c4.41,0,8.83-.16,13.24-.16l13.24-.07h.5v.5l-.06,11.19v.45h-.44c-2.23,0-4.47,0-6.7-.06l-6.66-.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "340.355px 135.5px"
    },
    id: "elua16slluv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9wenqpclb6b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.46,
    y: 129.93,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "310.7px 135.525px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elyv8g3br4gae"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.73,
    y: 395.57,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "71.97px 401.165px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsrx5j6l95am"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.73,
    y: 43.24,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "71.97px 48.835px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44,68.54l13.35-.28,6.58-.11c2.19,0,4.36,0,6.55-.05l-.45.44,0-11.19.5.5L57.2,57.79c-4.42,0-8.83-.11-13.24-.16l.27-.28c0,1.83-.09,3.68-.13,5.54Zm0,0L43.81,63c0-1.87-.11-3.76-.13-5.66v-.27H44c4.41,0,8.82-.16,13.24-.16l13.24-.07h.5v.5l-.06,11.19V69h-.44c-2.24,0-4.47,0-6.7-.06l-6.66-.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "57.33px 62.92px"
    },
    id: "eluoa8jfrw1bc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.56,54.45l13.36-.28,6.58-.12c2.19,0,4.36,0,6.54,0l-.44.45-.05-11.19.49.49-13.24-.06c-4.41,0-8.82-.11-13.24-.16l.28-.27c0,1.83-.09,3.67-.13,5.53Zm0,0-.14-5.54c0-1.87-.11-3.76-.13-5.65V43h.27c4.42,0,8.83-.16,13.24-.16L456,42.76h.51v.51l-.05,11.19v.44H456c-2.23,0-4.46,0-6.69,0l-6.66-.12Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "442.9px 48.83px"
    },
    id: "el2i0r6wq2cs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 317.02,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "310.56px 322.615px"
    },
    id: "elksqh475cmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,302.91l-13.36.28-6.58.11c-2.18.05-4.36,0-6.54.05l.44-.44.06,11.19-.5-.5,13.24.06c4.41,0,8.83.11,13.24.17l-.27.27c0-1.83.08-3.67.13-5.54Zm0,0,.14,5.54c.05,1.86.11,3.75.13,5.65v.27H309c-4.41.05-8.83.16-13.24.17l-13.24.06h-.5v-.5l.05-11.19v-.45h.44c2.23,0,4.47,0,6.69.06l6.66.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "295.645px 308.53px"
    },
    id: "el48c902szbv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.2,280.78H79.85V40.13H438.2Zm-357.35-1H437.2V41.13H80.85Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "259.025px 160.455px"
    },
    id: "elj2fp6vvsb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.77,45.72a2.53,2.53,0,1,1-2.53-2.53A2.52,2.52,0,0,1,89.77,45.72Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "87.24px 45.72px"
    },
    id: "el3hbv3jz3s45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.08,45.72a2.53,2.53,0,1,1-2.52-2.53A2.52,2.52,0,0,1,100.08,45.72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "97.55px 45.72px"
    },
    id: "el26o6wrpd5go",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4,45.72a2.53,2.53,0,1,1-2.53-2.53A2.52,2.52,0,0,1,110.4,45.72Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "107.87px 45.72px"
    },
    id: "elnqs4t37y6mm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.35,
    y: 50.17,
    width: 357.35,
    height: 1,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "259.025px 50.67px"
    },
    id: "elbl56cbuohyb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-127",
    className: "animable",
    style: {
      transformOrigin: "249.53px 180.705px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.93,
    y: 60.94,
    width: 357.36,
    height: 239.65,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "249.61px 180.765px"
    },
    id: "elz4ymfld6u99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.28,300.59l-357.35.16h-.17v-.17l-.1-239.65v-.27h.28l357.35.16h.11v.11Zm0,0-.11-239.65.11.11-357.35.16.27-.27-.11,239.65-.16-.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "249.53px 180.705px"
    },
    id: "elw1fk27704r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.93,
    y: 60.94,
    width: 357.36,
    height: 36.98,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "249.61px 79.43px"
    },
    id: "elgjy6sxueqxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.93,
    y: 60.94,
    width: 357.36,
    height: 9.93,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "249.61px 65.905px"
    },
    id: "elc6js6ve7yl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.82,65.91a2.46,2.46,0,1,1-2.46-2.47A2.46,2.46,0,0,1,78.82,65.91Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "76.36px 65.9px"
    },
    id: "elxdsx9rw0jjp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.88,65.91a2.46,2.46,0,1,1-2.46-2.47A2.46,2.46,0,0,1,88.88,65.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "86.42px 65.9px"
    },
    id: "elvdo3cjki5ma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.94,65.91a2.46,2.46,0,1,1-2.46-2.47A2.46,2.46,0,0,1,98.94,65.91Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "96.48px 65.9px"
    },
    id: "elg0msxmvnjyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.47,86.7a.45.45,0,0,1,.62-.06,2.79,2.79,0,0,0,1.64.66A1.8,1.8,0,0,0,88.79,87a.76.76,0,0,0,.37-.62.48.48,0,0,0-.08-.27.75.75,0,0,0-.25-.26,3.43,3.43,0,0,0-1.17-.4h0a4.89,4.89,0,0,1-1.1-.33,1.88,1.88,0,0,1-.8-.67,1.27,1.27,0,0,1-.19-.7,1.59,1.59,0,0,1,.68-1.25A2.52,2.52,0,0,1,87.71,82a3.37,3.37,0,0,1,1.86.68.44.44,0,0,1,.12.61.45.45,0,0,1-.61.13,2.46,2.46,0,0,0-1.37-.55,1.63,1.63,0,0,0-1,.29.68.68,0,0,0-.32.54.38.38,0,0,0,.06.24.81.81,0,0,0,.23.22,3,3,0,0,0,1.07.38h0a4.42,4.42,0,0,1,1.18.36,2,2,0,0,1,.86.71,1.44,1.44,0,0,1,.2.72,1.68,1.68,0,0,1-.73,1.33,2.74,2.74,0,0,1-1.58.48,3.69,3.69,0,0,1-2.19-.85A.46.46,0,0,1,85.47,86.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "87.6813px 85.0701px"
    },
    id: "elvx4yl4n7w6m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,86.06a2.1,2.1,0,0,1,2.08-2.14,2,2,0,0,1,2.06,2v0a.22.22,0,0,1,0,.08.4.4,0,0,1-.44.34H91.94a1.15,1.15,0,0,0,.29.57,1.31,1.31,0,0,0,.82.38,1.38,1.38,0,0,0,.89-.21.49.49,0,0,1,.64,0,.39.39,0,0,1,0,.56,2.17,2.17,0,0,1-1.53.56A2.11,2.11,0,0,1,91,86.06Zm.93-.42h2.42a1.42,1.42,0,0,0-1.27-.91A1.21,1.21,0,0,0,91.9,85.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "93.0716px 86.0602px"
    },
    id: "elendj9ym9syc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.05,84.39a.48.48,0,0,1-.48.47h-.21v2.38a.48.48,0,0,1,.47.48.46.46,0,0,1-.47.47,1,1,0,0,1-1-1V84.86h-.25a.47.47,0,0,1-.47-.47.46.46,0,0,1,.47-.47h.25V82.68a.47.47,0,0,1,.48-.47.46.46,0,0,1,.47.47v1.24h.21A.47.47,0,0,1,98.05,84.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "96.845px 85.2px"
    },
    id: "elbv3uvzjqrya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.24,88.19a1.79,1.79,0,0,1-1.78-1.78v-2a.46.46,0,0,1,.46-.45.45.45,0,0,1,.45.45v2a.87.87,0,0,0,.87.88.89.89,0,0,0,.9-.88v-2a.45.45,0,0,1,.44-.45.47.47,0,0,1,.46.45v2A1.8,1.8,0,0,1,101.24,88.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "101.25px 86.075px"
    },
    id: "elqox7wqnrt5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.79,89.34V86.07h0V84.37a.45.45,0,0,1,.45-.45.46.46,0,0,1,.47.35,2.14,2.14,0,0,1,1.16-.35,2.13,2.13,0,0,1,0,4.26,1.93,1.93,0,0,1-1.14-.35v1.51a.48.48,0,0,1-.49.46A.46.46,0,0,1,104.79,89.34Zm.94-3.28a1.15,1.15,0,0,0,.33.86,1.07,1.07,0,0,0,.81.36,1.1,1.1,0,0,0,.81-.36,1.28,1.28,0,0,0,.33-.86,1.34,1.34,0,0,0-.33-.86,1.13,1.13,0,0,0-.81-.35,1.1,1.1,0,0,0-.81.35A1.2,1.2,0,0,0,105.73,86.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "106.895px 86.8598px"
    },
    id: "el6w7nl6xf6f7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,82.92l-2.09,5a.22.22,0,0,1,0,.08h0l0,.05s0,0,0,0l-.06,0h0s0,0-.07,0h0a0,0,0,0,0,0,0h-.35l-.08,0h0l-.06,0v0l0-.05h0a.2.2,0,0,1,0-.08l-1.12-2.65-1.12,2.65,0,.08h0l0,.05s0,0,0,0,0,0,0,0h0l-.07,0h0a0,0,0,0,0,0,0h-.35s0,0,0,0l-.08,0h0s0,0-.06,0,0,0,0,0l0-.05h0a.59.59,0,0,0,0-.08l-2.1-5a.47.47,0,1,1,.86-.36l1.68,4,1.1-2.63a.47.47,0,0,1,.44-.29.51.51,0,0,1,.45.29l1.1,2.63,1.67-4a.47.47,0,1,1,.86.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "117.47px 85.1323px"
    },
    id: "elmcbhid84chn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.22,82.85a.46.46,0,1,1-.92,0v-.18a.46.46,0,1,1,.92,0Zm0,1.55v3.33a.46.46,0,1,1-.92,0V84.4a.46.46,0,1,1,.92,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "122.76px 85.2px"
    },
    id: "eljb10deq6ti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.7,84.64l-1.93,2.65h1.57a.45.45,0,0,1,.45.45.45.45,0,0,1-.45.45h-2.63l0,0,0,0,0,0s0,0,0,0l0,0,0,0a.11.11,0,0,0,0,0l0,0s0,0,0,0,0,0,0,0,0,0,0,0v-.1s0,0,0,0h0s0,0,0-.06v0a.11.11,0,0,1,0,0s0,0,0,0l0,0a.08.08,0,0,1,0,0h0l1.92-2.65h-1.56a.46.46,0,0,1,0-.91h2.65l0,0,.06,0h0a0,0,0,0,1,0,0s0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0a.06.06,0,0,1,0,0,.11.11,0,0,1,0,.05v0s0,0,0,0h0a.1.1,0,0,0,0,0v.06a.1.1,0,0,1,0,0,.05.05,0,0,1,0,0v0s0,0,0,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "126.234px 86.33px"
    },
    id: "eln5vpuif9fbo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,86.06v1.68a.45.45,0,0,1-.45.45.48.48,0,0,1-.45-.37,1.87,1.87,0,0,1-1.13.37,2,2,0,0,1-1.46-.62,2.23,2.23,0,0,1-.58-1.51,2.17,2.17,0,0,1,.58-1.5,2,2,0,0,1,1.46-.64,1.88,1.88,0,0,1,1.13.38.48.48,0,0,1,.45-.38.45.45,0,0,1,.45.46Zm-.9,0a1.27,1.27,0,0,0-.34-.88,1.08,1.08,0,0,0-1.59,0,1.37,1.37,0,0,0,0,1.76,1.1,1.1,0,0,0,1.59,0A1.27,1.27,0,0,0,132.14,86.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.965px 86.055px"
    },
    id: "elxm0a1zbsqnd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.35,84.37a.46.46,0,0,1-.45.46.85.85,0,0,0-.52.16,1.27,1.27,0,0,0-.39.41,2.64,2.64,0,0,0-.35.72v1.62a.46.46,0,0,1-.47.45.45.45,0,0,1-.45-.45V84.37a.44.44,0,0,1,.45-.44.45.45,0,0,1,.47.44v.06a1,1,0,0,1,.18-.17,1.85,1.85,0,0,1,1.08-.33A.44.44,0,0,1,137.35,84.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "136.035px 86.0598px"
    },
    id: "el2hy9r7sbdx2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.13,87.73a.47.47,0,0,1-.46.46.47.47,0,0,1-.46-.37,2,2,0,0,1-1.16.37,2.14,2.14,0,0,1,0-4.27,2.06,2.06,0,0,1,1.15.36V82.67a.47.47,0,0,1,.93,0v3.39h0Zm-2.08-2.88a1.1,1.1,0,0,0-.8.35,1.25,1.25,0,0,0,0,1.71,1.1,1.1,0,0,0,.8.35,1.08,1.08,0,0,0,.8-.35,1.22,1.22,0,0,0,0-1.71A1.08,1.08,0,0,0,140.05,84.85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "140.093px 85.2292px"
    },
    id: "eldybb0th8uc5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.72,
    y: 115.79,
    width: 134.9,
    height: 1.09,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "314.17px 116.335px"
    },
    id: "elyb00t4hepy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 246.72,
    cy: 116.34,
    r: 6.26,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "246.72px 116.34px"
    },
    id: "el9l3kt30tijv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.44,
    cy: 116.34,
    r: 6.26,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "280.44px 116.34px"
    },
    id: "elscs0lkrefeo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.44,123.15a6.81,6.81,0,1,1,6.81-6.81A6.82,6.82,0,0,1,280.44,123.15Zm0-12.53a5.72,5.72,0,1,0,5.72,5.72A5.72,5.72,0,0,0,280.44,110.62Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "280.44px 116.34px"
    },
    id: "elpu2uyvtslc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.17,
    cy: 116.34,
    r: 6.26,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "314.17px 116.34px"
    },
    id: "elf2isfpf6314",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.17,123.15a6.81,6.81,0,1,1,6.81-6.81A6.82,6.82,0,0,1,314.17,123.15Zm0-12.53a5.72,5.72,0,1,0,5.71,5.72A5.73,5.73,0,0,0,314.17,110.62Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "314.17px 116.34px"
    },
    id: "elf8u4zlyf47",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.89,
    cy: 116.34,
    r: 6.26,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "347.89px 116.34px"
    },
    id: "elkxwyxoharl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.89,123.15a6.81,6.81,0,1,1,6.81-6.81A6.82,6.82,0,0,1,347.89,123.15Zm0-12.53a5.72,5.72,0,1,0,5.72,5.72A5.72,5.72,0,0,0,347.89,110.62Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "347.89px 116.34px"
    },
    id: "elyifmb815kt7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 381.62,
    cy: 116.34,
    r: 6.26,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "381.62px 116.34px"
    },
    id: "el538twqgt0n7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.62,123.15a6.81,6.81,0,1,1,6.81-6.81A6.82,6.82,0,0,1,381.62,123.15Zm0-12.53a5.72,5.72,0,1,0,5.71,5.72A5.73,5.73,0,0,0,381.62,110.62Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "381.62px 116.34px"
    },
    id: "ellpiz1eky01",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.21,115v2.79a.26.26,0,0,1-.26.25.25.25,0,0,1-.26-.25v-2.32l-.19.1a.22.22,0,0,1-.13,0,.26.26,0,0,1-.22-.13.25.25,0,0,1,.08-.35l.58-.35h.24l0,0h0s0,0,0,0h0s0,0,0,0l0,0h0v0s0,0,0,0a0,0,0,0,1,0,0s0,0,0,0v0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "246.66px 116.39px"
    },
    id: "elh0v0zre9nj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.49,117.81a.25.25,0,0,1-.26.25h-1.68a.24.24,0,0,1-.19-.08.27.27,0,0,1,0-.37l1.4-1.26a.57.57,0,0,0,.2-.45.56.56,0,0,0-.16-.41.59.59,0,0,0-.45-.2.63.63,0,0,0-.41.15l-.15.13a.26.26,0,1,1-.35-.38l.15-.13a1.13,1.13,0,0,1,1.89.84,1.14,1.14,0,0,1-.37.83l-.89.81h1A.26.26,0,0,1,281.49,117.81Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "280.388px 116.413px"
    },
    id: "elq5ypkd4yp6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.83,116.06a1.16,1.16,0,0,1,.34.83,1.17,1.17,0,0,1-2,.83.28.28,0,0,1,0-.38.26.26,0,0,1,.38,0,.63.63,0,0,0,.45.18.66.66,0,0,0,.45-.18.63.63,0,0,0,.19-.45.65.65,0,0,0-.64-.64.22.22,0,0,1-.19-.09h0a.27.27,0,0,1,0-.38l.48-.49h-.76a.27.27,0,0,1,0-.53h1.39a.27.27,0,0,1,.27.26.28.28,0,0,1,0,.13l-.05.07-.59.61A1.23,1.23,0,0,1,314.83,116.06Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "314.147px 116.413px"
    },
    id: "el3993r9ymdv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.16,117.19a.27.27,0,0,1-.27.26h0v.36a.26.26,0,0,1-.26.25.25.25,0,0,1-.26-.25v-.36h-1.49a.27.27,0,0,1-.16-.06.26.26,0,0,1,0-.36l1.75-2.17a0,0,0,0,1,0,0v0h0s0,0,0,0h0s0,0,0,0,0,0,0,0h.17l0,0,0,0h0l0,0s0,0,0,0a0,0,0,0,1,0,0,0,0,0,0,0,0,0s0,0,0,0v0a0,0,0,0,1,0,0h0v1.91h0A.27.27,0,0,1,349.16,117.19Zm-.83-1.43-.94,1.17h.94Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "347.94px 116.46px"
    },
    id: "el4v6ve697ah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.24,116.07a1.13,1.13,0,0,1,.34.82,1.16,1.16,0,0,1-1.16,1.17h0a1.13,1.13,0,0,1-.82-.34.26.26,0,0,1,0-.38.27.27,0,0,1,.37,0,.63.63,0,0,0,.46.19.59.59,0,0,0,.44-.19.6.6,0,0,0,.19-.45.61.61,0,0,0-.19-.45.62.62,0,0,0-.44-.18.67.67,0,0,0-.46.18.25.25,0,0,1-.37,0l-.06-.06h0s0,0,0,0,0,0,0,0h0v-.08l.14-1.22a.31.31,0,0,1,.12-.19h0a.27.27,0,0,1,.12,0h1.4a.26.26,0,0,1,.26.27.27.27,0,0,1-.26.27h-1.16l-.06.46a1.65,1.65,0,0,1,.32,0A1.13,1.13,0,0,1,382.24,116.07Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "381.549px 116.472px"
    },
    id: "elkbjp1vpeg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.93,
    y: 97.92,
    width: 129.12,
    height: 202.45,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "135.49px 199.145px"
    },
    id: "ellilb2rauqaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.28,169.63V165a.43.43,0,0,1,.43-.43.44.44,0,0,1,.45.43v1.9h2.05V165a.43.43,0,0,1,.43-.43.44.44,0,0,1,.45.43v4.67a.44.44,0,0,1-.45.44.43.43,0,0,1-.43-.44v-1.9h-2.05v1.9a.44.44,0,0,1-.45.44A.43.43,0,0,1,241.28,169.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.184px 167.34px"
    },
    id: "elf5tt4nd8z8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.67,165.12a.43.43,0,0,1-.43.44.43.43,0,0,1-.42-.44V165a.43.43,0,0,1,.85,0Zm0,1.43v3.09a.43.43,0,1,1-.85,0v-3.09a.43.43,0,1,1,.85,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "247.245px 167.385px"
    },
    id: "el2237amj8scr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.19,166.55a.44.44,0,0,1-.44.43h-.2v2.21a.44.44,0,0,1,.44.44.43.43,0,0,1-.44.44.89.89,0,0,1-.88-.88V167h-.23a.44.44,0,0,1,0-.87h.23V165a.44.44,0,0,1,.45-.43.43.43,0,0,1,.43.43v1.15h.2A.44.44,0,0,1,253.19,166.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.128px 167.32px"
    },
    id: "elnyv013bxvbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.3,169.63a.43.43,0,0,1-.44.44.45.45,0,0,1-.42-.33.36.36,0,0,1,0-.11V165a.44.44,0,0,1,.44-.43.43.43,0,0,1,.44.43v1.38a1.77,1.77,0,0,1,.85-.23,1.73,1.73,0,0,1,1.73,1.73v1.79a.44.44,0,1,1-.87,0v-1.79a.86.86,0,0,0-1.71,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "256.17px 167.373px"
    },
    id: "el8hragd3p6ls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,168.09a2,2,0,0,1,1.94-2,1.89,1.89,0,0,1,1.9,1.84v.11a.38.38,0,0,1-.42.31h-2.51a1,1,0,0,0,.27.53,1.18,1.18,0,0,0,.76.35,1.26,1.26,0,0,0,.82-.19.45.45,0,0,1,.59,0,.36.36,0,0,1,0,.52,2,2,0,0,1-1.41.52A2,2,0,0,1,259,168.09Zm.87-.39h2.24a1.31,1.31,0,0,0-1.17-.84A1.1,1.1,0,0,0,259.87,167.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.92px 168.085px"
    },
    id: "el7hms22h90v5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.38,166.53a.42.42,0,0,1-.42.42.81.81,0,0,0-.48.15,1.09,1.09,0,0,0-.36.38,2.45,2.45,0,0,0-.33.66v1.51a.43.43,0,0,1-.85,0v-3.12a.43.43,0,0,1,.85,0v.05l.17-.15a1.68,1.68,0,0,1,1-.31A.41.41,0,0,1,266.38,166.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "265.16px 168.067px"
    },
    id: "elkpcct5fjgx9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.75,168.09a2,2,0,0,1,1.93-2,1.9,1.9,0,0,1,1.91,1.84v0a.2.2,0,0,1,0,.07.38.38,0,0,1-.41.31h-2.52a1.08,1.08,0,0,0,.27.53,1.18,1.18,0,0,0,.76.35,1.26,1.26,0,0,0,.82-.19.46.46,0,0,1,.6,0,.37.37,0,0,1,0,.52,2,2,0,0,1-1.42.52A2,2,0,0,1,266.75,168.09Zm.86-.39h2.24a1.29,1.29,0,0,0-1.17-.84A1.1,1.1,0,0,0,267.61,167.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "268.672px 168.066px"
    },
    id: "elv7tyu186cc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.85,168.16V165a.43.43,0,0,1,.43-.43.43.43,0,0,1,.43.43v3.2a.43.43,0,0,1-.43.44A.44.44,0,0,1,271.85,168.16Zm.43,1.91a.44.44,0,0,1-.43-.44v-.15a.44.44,0,0,1,.43-.44.44.44,0,0,1,.43.44v.15A.43.43,0,0,1,272.28,170.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "272.279px 167.32px"
    },
    id: "elcumxgsiu4yj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.28 183.02 259.6 182.89 277.93 182.84 314.58 182.75 351.23 182.84 369.55 182.89 387.88 183.02 369.55 183.16 351.23 183.2 314.58 183.3 277.93 183.2 259.6 183.16 241.28 183.02",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "314.58px 183.025px"
    },
    id: "el7jsmtx0o5p7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.28 189.83 259.6 189.7 277.93 189.65 314.58 189.56 351.23 189.65 369.55 189.69 387.88 189.83 369.55 189.96 351.23 190.01 314.58 190.1 277.93 190.01 259.6 189.96 241.28 189.83",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "314.58px 189.83px"
    },
    id: "elj069nqqspq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.28 196.63 259.6 196.5 277.93 196.45 314.58 196.36 351.23 196.45 369.55 196.5 387.88 196.63 369.55 196.77 351.23 196.82 314.58 196.91 277.93 196.82 259.6 196.77 241.28 196.63",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "314.58px 196.635px"
    },
    id: "elyecxll35ufg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.28 203.44 254.1 203.31 266.92 203.26 292.56 203.17 318.21 203.26 331.03 203.31 343.85 203.44 331.03 203.57 318.21 203.62 292.56 203.71 266.92 203.62 254.1 203.57 241.28 203.44",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "292.565px 203.44px"
    },
    id: "el18fn1pnte2t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.28 217.05 259.6 216.92 277.93 216.87 314.58 216.78 351.23 216.87 369.55 216.92 387.88 217.05 369.55 217.19 351.23 217.24 314.58 217.33 277.93 217.24 259.6 217.19 241.28 217.05",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "314.58px 217.055px"
    },
    id: "elpcv5m8fu3jq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.28 223.86 259.6 223.73 277.93 223.68 314.58 223.59 351.23 223.68 369.55 223.73 387.88 223.86 369.55 223.99 351.23 224.04 314.58 224.13 277.93 224.04 259.6 223.99 241.28 223.86",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "314.58px 223.86px"
    },
    id: "elzlj5pbhbsaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.28 230.67 254.1 230.53 266.92 230.48 292.56 230.39 318.21 230.48 331.03 230.53 343.85 230.67 331.03 230.8 318.21 230.85 292.56 230.94 266.92 230.85 254.1 230.8 241.28 230.67",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "292.565px 230.665px"
    },
    id: "eloxqp1qf79h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.28,
    y: 271.78,
    width: 50.71,
    height: 14.23,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "266.635px 278.895px"
    },
    id: "ell4r6l5rkjfi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.69,280v-2.78a.26.26,0,0,1,.26-.26.26.26,0,0,1,.26.26v2.51h1.28a.27.27,0,0,1,0,.53H256A.26.26,0,0,1,255.69,280Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "256.699px 278.612px"
    },
    id: "elppg62hq0c3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.07,279a1.18,1.18,0,0,1,1.15-1.18,1.13,1.13,0,0,1,1.14,1.09v0a.06.06,0,0,1,0,0,.22.22,0,0,1-.24.19h-1.5a.62.62,0,0,0,.16.31.73.73,0,0,0,.45.21.72.72,0,0,0,.49-.12.27.27,0,0,1,.36,0,.23.23,0,0,1,0,.31,1.2,1.2,0,0,1-.85.31A1.18,1.18,0,0,1,258.07,279Zm.52-.23h1.33a.77.77,0,0,0-.7-.5A.64.64,0,0,0,258.59,278.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "259.215px 278.97px"
    },
    id: "elxulq12rd8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,278.12a.27.27,0,0,1-.27.26h-.12v1.31a.27.27,0,0,1,0,.53.53.53,0,0,1-.52-.53v-1.31h-.14a.26.26,0,0,1-.25-.26.25.25,0,0,1,.25-.26h.14v-.68a.26.26,0,0,1,.27-.26.25.25,0,0,1,.25.26v.68h.12A.27.27,0,0,1,262,278.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "261.35px 278.57px"
    },
    id: "elakgsjrmk3wu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.79,278a.4.4,0,0,0,.32-.43.32.32,0,0,1-.26-.31v0a.3.3,0,0,1,.32-.32c.2,0,.34.16.34.42v.05a.89.89,0,0,1-.24.68.67.67,0,0,1-.44.21.12.12,0,0,1-.14-.13A.13.13,0,0,1,262.79,278Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "263.098px 277.621px"
    },
    id: "elpx5q105y5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.67,279.54a.25.25,0,0,1,.36,0,.83.83,0,0,0,.52.2.63.63,0,0,0,.32-.09.19.19,0,0,0,.08-.14s0,0,0,0a.17.17,0,0,0-.06-.06,1,1,0,0,0-.38-.13h0a2,2,0,0,1-.41-.13.75.75,0,0,1-.32-.27.58.58,0,0,1-.08-.3A.63.63,0,0,1,264,278a1,1,0,0,1,.58-.18,1.23,1.23,0,0,1,.7.26.26.26,0,0,1,.08.35.25.25,0,0,1-.35.06.86.86,0,0,0-.43-.17.5.5,0,0,0-.29.09c-.06,0-.07.08-.07.1s0,0,0,0,0,0,.05.05a1,1,0,0,0,.34.11h0a1.5,1.5,0,0,1,.44.13.77.77,0,0,1,.34.28.69.69,0,0,1,.09.31.69.69,0,0,1-.3.55,1.05,1.05,0,0,1-.61.19,1.41,1.41,0,0,1-.84-.33A.25.25,0,0,1,263.67,279.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "264.568px 278.975px"
    },
    id: "elmwtk4m33eid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.4,279.54a.25.25,0,0,1,.36,0,.83.83,0,0,0,.51.2.64.64,0,0,0,.33-.09.19.19,0,0,0,.08-.14s0,0,0,0a.14.14,0,0,0-.07-.06.91.91,0,0,0-.37-.13h0a2,2,0,0,1-.41-.13.75.75,0,0,1-.32-.27.58.58,0,0,1-.08-.3.63.63,0,0,1,.28-.51,1,1,0,0,1,.58-.18,1.23,1.23,0,0,1,.7.26.26.26,0,0,1,.08.35.25.25,0,0,1-.35.06.86.86,0,0,0-.43-.17.48.48,0,0,0-.29.09c-.06,0-.07.08-.07.1s0,0,0,0,0,0,.05.05a1,1,0,0,0,.34.11h0a1.6,1.6,0,0,1,.44.13.74.74,0,0,1,.33.28.59.59,0,0,1,.09.31.68.68,0,0,1-.29.55,1.06,1.06,0,0,1-.62.19,1.38,1.38,0,0,1-.83-.33A.25.25,0,0,1,267.4,279.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "268.258px 279.085px"
    },
    id: "elprgv1j1iqz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,278.12a.26.26,0,0,1-.26.26h-.12v1.31a.27.27,0,0,1,0,.53.52.52,0,0,1-.52-.53v-1.31h-.14a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h.14v-.68a.26.26,0,0,1,.26-.26.25.25,0,0,1,.26.26v.68h.12A.26.26,0,0,1,271,278.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "270.35px 278.57px"
    },
    id: "elea5iu970d78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,279V280a.25.25,0,0,1-.25.25.27.27,0,0,1-.25-.21,1.05,1.05,0,0,1-.62.21,1.1,1.1,0,0,1-.81-.35,1.21,1.21,0,0,1-.32-.83,1.23,1.23,0,0,1,.32-.83,1.14,1.14,0,0,1,.81-.35,1.05,1.05,0,0,1,.62.21.27.27,0,0,1,.25-.21.25.25,0,0,1,.25.26Zm-.5,0a.71.71,0,0,0-.18-.48.59.59,0,0,0-.44-.19.56.56,0,0,0-.44.19.66.66,0,0,0-.18.48.67.67,0,0,0,.18.49.59.59,0,0,0,.44.18.62.62,0,0,0,.44-.18A.72.72,0,0,0,273.14,279Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "272.515px 279.07px"
    },
    id: "elfjy48l12c2h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,278.11a.25.25,0,0,1-.25.25.45.45,0,0,0-.28.09.8.8,0,0,0-.22.23,1.45,1.45,0,0,0-.19.39v.9a.26.26,0,0,1-.26.25.25.25,0,0,1-.25-.25v-1.86a.24.24,0,0,1,.25-.24.25.25,0,0,1,.26.24v0a.43.43,0,0,1,.1-.09,1,1,0,0,1,.59-.18A.24.24,0,0,1,276,278.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "275.276px 279.03px"
    },
    id: "el2my57ixddpj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.69,278.12a.27.27,0,0,1-.27.26h-.12v1.31a.27.27,0,0,1,0,.53.53.53,0,0,1-.52-.53v-1.31h-.14a.26.26,0,0,1-.26-.26.26.26,0,0,1,.26-.26h.14v-.68a.26.26,0,0,1,.26-.26.25.25,0,0,1,.26.26v.68h.12A.27.27,0,0,1,277.69,278.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "277.035px 278.57px"
    },
    id: "eluvaa4mz3t8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.17,
    y: 271.78,
    width: 50.71,
    height: 14.23,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "328.525px 278.895px"
    },
    id: "elcj5ershdypt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.85,278.52a1.75,1.75,0,0,1,2.82-1.33.28.28,0,0,1,.05.38.27.27,0,0,1-.38.05,1.17,1.17,0,0,0-.76-.26,1.27,1.27,0,0,0-.85.34,1.17,1.17,0,0,0-.34.82,1.16,1.16,0,0,0,.34.82,1.27,1.27,0,0,0,.85.34,1.17,1.17,0,0,0,.76-.26.29.29,0,0,1,.38.05.28.28,0,0,1-.05.38,1.75,1.75,0,0,1-1.09.37A1.73,1.73,0,0,1,320.85,278.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "322.311px 278.522px"
    },
    id: "el7vouto42err",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.57,279V280a.25.25,0,0,1-.25.25.25.25,0,0,1-.24-.21,1.07,1.07,0,0,1-1.43-.14,1.21,1.21,0,0,1-.32-.83,1.23,1.23,0,0,1,.32-.83,1.1,1.1,0,0,1,.8-.35,1.06,1.06,0,0,1,.63.21.25.25,0,0,1,.24-.21.25.25,0,0,1,.25.26Zm-.5,0a.71.71,0,0,0-.18-.48.59.59,0,0,0-.44-.19.56.56,0,0,0-.44.19.71.71,0,0,0-.18.48.72.72,0,0,0,.18.49.59.59,0,0,0,.44.18.62.62,0,0,0,.44-.18A.72.72,0,0,0,326.07,279Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "325.45px 279.07px"
    },
    id: "eley976x4n0qm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.41,278.84V280a.25.25,0,0,1-.25.25.26.26,0,0,1-.25-.25v-1.13a.48.48,0,0,0-.49-.47.47.47,0,0,0-.47.47V280a.06.06,0,0,1,0,0,.25.25,0,0,1-.25.21.25.25,0,0,1-.25-.25v-1.86a.25.25,0,0,1,.25-.25.25.25,0,0,1,.23.15,1,1,0,0,1,.5-.15A1,1,0,0,1,329.41,278.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "328.43px 279.05px"
    },
    id: "elvtkh8xj4yrf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.17,279a1.2,1.2,0,0,1,1.94-.92.25.25,0,0,1-.3.4.74.74,0,0,0-.45-.15.68.68,0,1,0,0,1.35.76.76,0,0,0,.45-.15.25.25,0,0,1,.3.4,1.32,1.32,0,0,1-.75.25A1.19,1.19,0,0,1,330.17,279Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "331.189px 279.002px"
    },
    id: "elklbyui61kdk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.78,279a1.18,1.18,0,0,1,1.15-1.18,1.13,1.13,0,0,1,1.14,1.09v0a.06.06,0,0,1,0,0,.22.22,0,0,1-.24.19h-1.5a.62.62,0,0,0,.16.31.73.73,0,0,0,.45.21.72.72,0,0,0,.49-.12.27.27,0,0,1,.36,0,.23.23,0,0,1,0,.31,1.2,1.2,0,0,1-.85.31A1.18,1.18,0,0,1,332.78,279Zm.52-.23h1.33a.77.77,0,0,0-.7-.5A.64.64,0,0,0,333.3,278.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "333.925px 278.97px"
    },
    id: "eli20vch2qqcd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.11,276.92a.26.26,0,0,1,.26.26V280a.26.26,0,1,1-.52,0v-2.78A.26.26,0,0,1,336.11,276.92Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "336.108px 278.59px"
    },
    id: "el8vnsoxzsp6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.48,
    y: 188.51,
    width: 100.57,
    height: 79.3,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "149.765px 228.16px"
    },
    id: "elb3zmgp2for4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.35,
    y: 189.47,
    width: 99.7,
    height: 77.38,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "150.2px 228.16px"
    },
    id: "eldg37uegcgph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.04,
    y: 273.76,
    width: 116.01,
    height: 5.44,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "142.045px 276.48px"
    },
    id: "el2dbdibo9e87",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.05 267.81 200.05 273.76 84.04 273.76 99.48 267.81 200.05 267.81",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "142.045px 270.785px"
    },
    id: "elludi15ymk2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.05 267.81 200.05 271.65 100.86 271.65 110.83 267.81 200.05 267.81",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "150.455px 269.73px"
    },
    id: "el2ucnj96qck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.95,
    y: 195.35,
    width: 93.1,
    height: 65.62,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "153.5px 228.16px"
    },
    id: "elvf9p9rmr19k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.86,
    y: 195.35,
    width: 93.19,
    height: 2.53,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "153.455px 196.615px"
    },
    id: "elas5e2q3ja9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.87,196.61a.63.63,0,1,1-.63-.62A.63.63,0,0,1,108.87,196.61Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "108.24px 196.62px"
    },
    id: "el7nmaer26jhc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.43,196.61a.63.63,0,1,1-.63-.62A.63.63,0,0,1,111.43,196.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "110.8px 196.62px"
    },
    id: "elux2e4k4xhv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,196.61a.63.63,0,1,1-.62-.62A.63.63,0,0,1,114,196.61Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "113.37px 196.62px"
    },
    id: "elvm1ewxkdws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5pfzio7vidm"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "135.515px 193.41px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.39,106.14a24.52,24.52,0,0,0-5.18-8.22H83.72c-4.48,2.49-8.58,5.22-12.39,7.65a4.37,4.37,0,0,1-.4.25v23.46a117.44,117.44,0,0,0,11.46-7.75c4.2-3.16,8-6.11,11.83-8.54,1.91-1.22,3.86-2.33,5.86-3.36,1-.51,2-1,3-1.45l1.55-.68c.44-.19.88-.37,1.31-.53a22.82,22.82,0,0,1,5.26-1.29,16.26,16.26,0,0,1,5,.2,12,12,0,0,1,8,5.39,14.58,14.58,0,0,1,2,5.18,21.12,21.12,0,0,1,.11,6.22,33.62,33.62,0,0,1-4.69,12.86,42.94,42.94,0,0,1-9.32,10.84,65.67,65.67,0,0,1-12.34,8c-4.45,2.29-9.13,4.23-13.92,6.22S76.34,164.73,71.5,168c-.19.13-.39.25-.57.39v23.26c.29-1.82.63-3.59,1-5.26a31.84,31.84,0,0,1,.89-3.06c.16-.48.32-.92.51-1.35s.38-.87.6-1.3a22,22,0,0,1,3.72-5,55.58,55.58,0,0,1,11.64-8.45c8.72-5.09,18.37-9.43,26.85-16.06a65.3,65.3,0,0,0,6.1-5.34,59,59,0,0,0,5.41-6.16,49,49,0,0,0,7.93-14.88,31.28,31.28,0,0,0,1.42-9A26.2,26.2,0,0,0,135.39,106.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "103.968px 144.785px"
    },
    id: "elnnxk62hae4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.24,232.22a40.84,40.84,0,0,1-14.62-6.09,78.16,78.16,0,0,1-6.65-4.79L174.33,220l-1.63-1.37c-1.09-.94-2.21-1.86-3.31-2.82l-6.75-5.93a133.35,133.35,0,0,0-15.24-11.77,63.9,63.9,0,0,0-9.28-5A45.57,45.57,0,0,0,127.39,190a38.85,38.85,0,0,0-11.39-.15c-1,.16-2,.34-3,.52s-2,.54-2.94.85-1.92.76-2.85,1.19-1.82,1-2.67,1.53a25.36,25.36,0,0,0-7.77,8.32,39.83,39.83,0,0,0-3.89,9.23,79,79,0,0,0-2,9.1c-.55,3-.95,6-1.41,8.92-.86,5.9-1.73,11.73-3.11,17.44a66.38,66.38,0,0,1-6,16.45l-8.64,15.69-.76,1.42v8.39c0-.13.1-.26.14-.39.5-1.38,1-2.77,1.56-4.14l.82-2.05.86-2c2.33-5.44,5-10.76,7.77-16a104.86,104.86,0,0,0,6.84-16.65c1.89-5.68,3.55-11.41,5.43-17,.92-2.82,1.93-5.59,3-8.3a73.15,73.15,0,0,1,3.63-7.73,31.06,31.06,0,0,1,4.56-6.42,13.82,13.82,0,0,1,11.59-4.6,28.29,28.29,0,0,1,7,1.22,47.17,47.17,0,0,1,13.35,7.06c8.91,6.31,17.68,14.94,28.81,22.14a63,63,0,0,0,19,8.55,60.46,60.46,0,0,0,10.28,1.47c1.52.1,3,.17,4.5.19V232.8C199.1,232.62,198.16,232.43,197.24,232.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "135.53px 239.201px"
    },
    id: "elhjp2yry6bcb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.05,113.71V206c-.89.14-1.83.19-2.75.28s-2,0-3.07,0-2-.17-3-.29a13.41,13.41,0,0,1-1.48-.26l-1.46-.29-.73-.16-.71-.2-1.4-.42a22.94,22.94,0,0,1-2.75-1,44.57,44.57,0,0,1-9.84-5.46,51.78,51.78,0,0,1-14.3-16.05c-.44-.78-.86-1.56-1.27-2.34s-.77-1.61-1.14-2.42-.72-1.62-1-2.45-.65-1.64-.92-2.5a67.54,67.54,0,0,1-3.53-20.59,54,54,0,0,1,.76-10.12,34.14,34.14,0,0,1,3.11-9.48,22.35,22.35,0,0,1,6.59-7.7,37.5,37.5,0,0,1,9.12-4.8,100.94,100.94,0,0,1,20-5C193.53,114.26,196.8,113.92,200.05,113.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "175.37px 160.015px"
    },
    id: "elix7bzyismz9",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,141.86c-.29-.24-15.08-3.92-25.57,7.83-9.64,10.81-10.45,27.77-8.87,27.87,1.93.12,5.47-8.58,14.32-14.7,3.14-2.16,8.89-1.71,8.89-1.71Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "126.772px 159.345px"
    },
    id: "elpqj2b5g7lee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnj6a31jk478"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.08,161.15a21.69,21.69,0,0,0-5.09.29c1.27-4.87,3.65-14,5.19-19.85a25.08,25.08,0,0,1,11.12.27Z",
    style: {
      opacity: 0.1,
      transformOrigin: "136.145px 151.267px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.75,163.93c.29.23,7.06,13.89-2.17,26.65-8.48,11.74-24.88,16.16-25.32,14.64-.53-1.85,7.21-7.19,11.29-17.14,1.44-3.53-.24-9.05-.24-9.05Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "159.324px 184.719px"
    },
    id: "elmlwyv0uzizf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elribabm1n4o8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.4,174.81l-18.27,9.36a21.91,21.91,0,0,0-.82-5.14l16.44-15.1A25.25,25.25,0,0,1,174.4,174.81Z",
    style: {
      opacity: 0.1,
      transformOrigin: "164.855px 174.05px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.54,187.65l-16.28-13.09s3.35-19.87,17.39-35.49a102.67,102.67,0,0,1,23.77-19c11.07-6.55,20.79-9.71,22.68-8.18s.9,11.68-3.12,23.91a103,103,0,0,1-13.5,27.3C162.23,180.12,143.54,187.65,143.54,187.65Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "159.643px 149.58px"
    },
    id: "eljub8bdu0z6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,156.78a12,12,0,1,1-1.84-16.93A12,12,0,0,1,171,156.78Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "161.674px 149.229px"
    },
    id: "el6ni55zctib8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.43,155.56a12,12,0,1,1-1.83-16.93A12,12,0,0,1,171.43,155.56Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "162.108px 148.004px"
    },
    id: "elin0shcyxyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,153.24a8.35,8.35,0,1,1-1.28-11.74A8.36,8.36,0,0,1,168.56,153.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "162.049px 148.01px"
    },
    id: "elvahipj2j2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,153.24a8.23,8.23,0,0,1-2.33,2l-6.69.73a8.28,8.28,0,0,1-4.27-3.09l14.45-1.58A8,8,0,0,1,168.56,153.24Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "162.495px 153.635px"
    },
    id: "elwkn00zzibms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.18,142.34l-13.34,1.46a8.66,8.66,0,0,1,.7-1,8.35,8.35,0,0,1,11.74-1.29A8,8,0,0,1,168.18,142.34Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "161.51px 141.737px"
    },
    id: "elfihh80au7bk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.28,149.44l-15.95,1.74a7.43,7.43,0,0,1-.26-.71l16.31-1.78C170.36,148.94,170.32,149.19,170.28,149.44Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "162.225px 149.935px"
    },
    id: "elfdxbgtjytr6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,135.76,168.42,120c11.07-6.55,20.79-9.71,22.68-8.18S192,123.53,188,135.76Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "180.223px 123.6px"
    },
    id: "elfv4oq77ay44",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.41,120.72a.71.71,0,0,1-1,.11.7.7,0,0,1,.88-1.1A.69.69,0,0,1,173.41,120.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "172.856px 120.281px"
    },
    id: "elrea895acuws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.89,123.52a.71.71,0,0,1-1,.11.7.7,0,0,1-.1-1,.7.7,0,1,1,1.09.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "176.331px 123.078px"
    },
    id: "elod2egh7je6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.37,126.32a.7.7,0,0,1-1,.1.7.7,0,0,1,.88-1.09A.7.7,0,0,1,180.37,126.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "179.816px 125.88px"
    },
    id: "el6dbenfq08om",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.85,129.12a.7.7,0,0,1-1.09-.89.69.69,0,0,1,1-.1A.7.7,0,0,1,183.85,129.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "183.308px 128.67px"
    },
    id: "elkzjd7hi3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.33,131.91a.7.7,0,1,1-1.09-.88.7.7,0,0,1,1.09.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "186.785px 131.47px"
    },
    id: "el39aizipypdd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,173.46a.7.7,0,1,1-.11-1A.71.71,0,0,1,131,173.46Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "130.459px 173.013px"
    },
    id: "elz0sr1hlpw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5,176.26a.7.7,0,1,1-.11-1A.71.71,0,0,1,134.5,176.26Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "133.959px 175.813px"
    },
    id: "elr1lqs41ck3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,179.06a.7.7,0,1,1-.11-1A.71.71,0,0,1,138,179.06Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "137.459px 178.613px"
    },
    id: "el889r2jhndz6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.46,181.86a.7.7,0,1,1-.11-1A.71.71,0,0,1,141.46,181.86Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "140.919px 181.413px"
    },
    id: "el57w3f5wbxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94,184.66a.7.7,0,1,1-.11-1A.71.71,0,0,1,144.94,184.66Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "144.399px 184.213px"
    },
    id: "elnma3f8crh0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elknju2ylwuz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.27,111.52c-9.06,2.43-23.88,11-38.09,27.39-10.5,12.08-16.25,30.78-18.71,40.65l-6.21-5s3.35-19.87,17.39-35.49a102.67,102.67,0,0,1,23.77-19C178.35,114.16,187.18,111,190.27,111.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "158.765px 145.512px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "138.1 191.34 124.87 180.69 128.18 175.31 142.66 186.95 138.1 191.34",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "133.765px 183.325px"
    },
    id: "elnzrc3tstt9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcfy696xhjl"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "142.66 186.95 140.44 189.08 126.92 177.37 128.18 175.31 142.66 186.95",
    style: {
      opacity: 0.1,
      transformOrigin: "134.79px 182.195px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "188.14 137.5 183.15 138.12 181.74 143.25 180.94 137.99 176.06 136.78 181.04 135.87 182.46 131.02 183.29 136 188.14 137.5",
    style: {
      fill: "rgb(252, 252, 252)",
      transformOrigin: "182.1px 137.135px"
    },
    id: "elx2r66hki41",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.42 119.53 180.63 119.88 179.84 122.75 179.4 119.81 176.67 119.13 179.46 118.62 180.25 115.91 180.72 118.7 183.42 119.53",
    style: {
      fill: "rgb(252, 252, 252)",
      transformOrigin: "180.045px 119.33px"
    },
    id: "elzmcap23785",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.91 179.77 169.13 180.11 168.34 182.99 167.89 180.04 165.16 179.37 167.95 178.86 168.74 176.15 169.21 178.93 171.91 179.77",
    style: {
      fill: "rgb(252, 252, 252)",
      transformOrigin: "168.535px 179.57px"
    },
    id: "eltb7brxc5idp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.21 164.87 115.42 165.21 114.63 168.08 114.19 165.14 111.46 164.46 114.25 163.96 115.04 161.25 115.5 164.03 118.21 164.87",
    style: {
      fill: "rgb(252, 252, 252)",
      transformOrigin: "114.835px 164.665px"
    },
    id: "eldx5w872w6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln8awv6zzps"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.19,189A44.24,44.24,0,0,0,125,204.2a35.1,35.1,0,0,0-2.09,18.28,31.93,31.93,0,0,0,2.9,9,33.74,33.74,0,0,0,5.48,7.91,38.81,38.81,0,0,0,7.57,6.26,48.23,48.23,0,0,0,9,4.42,49.33,49.33,0,0,1-9.54-3.4,40.39,40.39,0,0,1-8.62-5.59,36.14,36.14,0,0,1-11.33-17.55,41,41,0,0,1,0-21.45,52.53,52.53,0,0,1,9.86-19.34Z",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.6,
      transformOrigin: "132.401px 216.405px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "128.11 198.27 126.22 199.01 126.18 201.17 125.34 199.18 123.3 199.19 125.17 198.34 125.24 196.29 126.06 198.17 128.11 198.27",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "125.705px 198.73px"
    },
    id: "eln6xhx339e2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.35 238.49 127.29 238.9 127.27 240.11 126.8 239 125.66 239 126.7 238.52 126.74 237.38 127.2 238.43 128.35 238.49",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "127.005px 238.745px"
    },
    id: "elzhwncmx0fu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.82 228.54 124.76 228.96 124.74 230.16 124.27 229.05 123.13 229.06 124.18 228.58 124.22 227.44 124.68 228.48 125.82 228.54",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "124.475px 228.8px"
    },
    id: "eljzq0t1wra9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.42 192.09 124.36 192.5 124.33 193.71 123.86 192.6 122.72 192.6 123.77 192.13 123.81 190.98 124.27 192.03 125.42 192.09",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "124.07px 192.345px"
    },
    id: "elgnskxt4fvxq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.43,240.49a.33.33,0,0,0,.13.64A.33.33,0,0,0,131.43,240.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "131.495px 240.81px"
    },
    id: "elted2ve6f5un",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,189.39a.33.33,0,0,0,.12.64A.33.33,0,0,0,131,189.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "131.06px 189.71px"
    },
    id: "elwbykg1oxag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.34,221.12a.32.32,0,0,0,.13.63A.32.32,0,0,0,119.34,221.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "119.405px 221.435px"
    },
    id: "elryykahgfju",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.55,238.94a.23.23,0,0,0,.08.45A.23.23,0,0,0,130.55,238.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.59px 239.165px"
    },
    id: "el8rmidq94er",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.08,210a.23.23,0,0,0,.09.45C117.46,210.4,117.37,210,117.08,210Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "117.129px 210.226px"
    },
    id: "el0h3qsqglfzpb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.82,232.62a.62.62,0,0,0,.23,1.22A.62.62,0,0,0,123.82,232.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "123.935px 233.23px"
    },
    id: "elht73ibjwvwc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.57,207.37a.63.63,0,0,0,.24,1.23A.63.63,0,0,0,119.57,207.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "119.69px 207.985px"
    },
    id: "el2rqohazxjyj",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-127",
    className: "animable",
    style: {
      transformOrigin: "250px 449.36px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "459.98 449.36 407.49 449.6 354.99 449.69 250 449.86 145.01 449.69 92.52 449.6 40.02 449.36 92.52 449.11 145.01 449.03 250 448.86 354.99 449.03 407.49 449.12 459.98 449.36",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250px 449.36px"
    },
    id: "else1shkhm0wa",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-127",
    className: "animable animator-active",
    style: {
      transformOrigin: "206.105px 342.814px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.88,449.31l160.79.69c39.08-30.69,43.12-76.15,15.24-103.71-16.88-16.67-38.3-13.31-58.71-16h-.06a60.28,60.28,0,0,1-20.69-6.07c-21-11.09-32.86-37.23-50.53-59.23q-3.3-4.14-6.92-8c-14.54-15.52-43.47-16-58.6,5.79C23,318.23,40.57,400.75,80.88,449.31Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "157.48px 347.911px"
    },
    id: "elkrbl8m835ag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwalfjqufa1d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.88,449.31l160.79.69c39.08-30.69,43.12-76.15,15.24-103.71-16.88-16.67-38.3-13.31-58.71-16h-.06a60.28,60.28,0,0,1-20.69-6.07c-21-11.09-32.86-37.23-50.53-59.23q-3.3-4.14-6.92-8c-14.54-15.52-43.47-16-58.6,5.79C23,318.23,40.57,400.75,80.88,449.31Z",
    style: {
      fill: "rgb(2, 1, 0)",
      opacity: 0.3,
      transformOrigin: "157.48px 347.911px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elyqsjtjkj4i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.31,322.46c4.21,66,80.4,90.6,128,70.83,41.37-17.18,27.83-56.4-7.09-63h-.06a60.28,60.28,0,0,1-20.69-6.07c-21-11.09-32.86-37.23-50.53-59.23C100.59,251.35,74.22,274.16,77.31,322.46Z",
    style: {
      fill: "rgb(2, 1, 0)",
      opacity: 0.3,
      transformOrigin: "153.975px 330.508px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.55,462.29c-2.5-.92-59-46.1-60.1-49.18-.41-1.17,5.69-9.79,13.35-20,1.66-2.2,3.38-4.47,5.14-6.76,11.43-14.88,23.9-30.41,23.9-30.41l37.9,30.11L220.8,415.65l-5.47,6.49s13.91,27,14.72,30.49S228.05,463.21,225.55,462.29Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "205.585px 409.156px"
    },
    id: "elfhnb0y5h47e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.55,462.29c-2.5-.92-59-46.1-60.1-49.18-.49-1.43,8.61-13.85,18.49-26.75l36.86,29.29-5.47,6.49s13.91,27,14.72,30.49S228.05,463.21,225.55,462.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "197.812px 424.366px"
    },
    id: "elo3u5kylv7ol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.55,462.29c-2.5-.92-59-46.1-60.1-49.18-.41-1.17,5.69-9.79,13.35-20l36.53,29s13.91,27,14.72,30.49S228.05,463.21,225.55,462.29Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "197.811px 427.741px"
    },
    id: "el90kt5d9bgfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.54,459.38c-9.29-7.81-47.49-38.41-57.27-45.42-.08-.06-.12,0,0,.06,9,7.94,47.49,38.23,57.19,45.52C226.63,459.69,226.74,459.54,226.54,459.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "197.921px 436.769px"
    },
    id: "elwl4dlfbew2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,447.69a9.79,9.79,0,0,0-7.52-2.22,9.44,9.44,0,0,0-6.16,3.37c-.05.06.06.14.11.09a11.28,11.28,0,0,1,13.47-1.12A.08.08,0,0,0,228,447.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.162px 447.17px"
    },
    id: "eltinflkwg1c9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.26,426c-3.75-3.08-9.22-5.26-14.06-4-.18,0-.12.32,0,.35A67.09,67.09,0,0,1,218,426.54.31.31,0,0,0,218.26,426Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "211.227px 424.091px"
    },
    id: "elrd7cai65y8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.27,429.5c-3.75-3.08-9.22-5.25-14.05-4-.19.05-.12.32,0,.35A67.19,67.19,0,0,1,220,430,.31.31,0,0,0,220.27,429.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "213.219px 427.571px"
    },
    id: "elt5s92lm9qmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.29,433c-3.75-3.09-9.22-5.26-14.06-4-.18,0-.11.31.05.34a66.6,66.6,0,0,1,13.7,4.22A.31.31,0,0,0,222.29,433Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "215.289px 431.118px"
    },
    id: "eldw1qmdixshs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.3,436.47c-3.75-3.09-9.21-5.26-14.05-4-.19,0-.12.31,0,.34A66.88,66.88,0,0,1,224,437,.3.3,0,0,0,224.3,436.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.293px 434.572px"
    },
    id: "elw4ae1cuo1rk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.88,406.89c-4.27-3.39-9.54,3.23-5.27,6.63S183.15,410.28,178.88,406.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "176.245px 410.206px"
    },
    id: "elavfxjignmp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.44,419.18c-.64-3.13-4.31-3.5-6.81-2.8a25.55,25.55,0,0,0-11.2,6.95c-.07.07,0,.15,0,.2a.6.6,0,0,0,.44.85c4.19.29,8.64,1.12,12.8.12C228.12,423.91,231.06,422.14,230.44,419.18Zm-11.09,4.34c-2.07-.09-4.12-.29-6.19-.3a74.81,74.81,0,0,1,6.63-3.91,27.11,27.11,0,0,1,3.43-1.45c1.83-.6,8.08-.79,5.16,3.63C226.77,423.94,221.81,423.63,219.35,423.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.448px 420.53px"
    },
    id: "elrn9ywro89hi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.88,417.2c2.9,3.15,7.06,4.93,10.71,7a.59.59,0,0,0,.83-.46c.08,0,.16-.05.14-.16a25.37,25.37,0,0,0-5.45-12c-1.68-2-4.94-3.7-7.21-1.47S200.19,415.36,201.88,417.2Zm-.56-4c0-5.3,5.13-1.66,6.31-.15a26.5,26.5,0,0,1,2.05,3.11c1.3,2.23,2.26,4.6,3.33,6.94-1.73-1.14-3.54-2.12-5.3-3.19C205.6,418.64,201.3,416.14,201.32,413.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "206.664px 416.654px"
    },
    id: "elq80jqflfc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,328.16c-2.6,19.69-51.13,76.54-56.73,83.06L226,412.7l-40.14-30.85.46-.59L221.68,335,116.24,345.58l27.31-30.79s3.25,1.87,10,.89c23.27-3.41,88.46-22.51,100.83-22C270.34,294.32,286.4,310.1,284,328.16Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "200.24px 353.185px"
    },
    id: "elgnehyy0jqlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.37,317.77a47.13,47.13,0,0,0-3.64,4.67c-1.25,1.64-2.52,3.26-3.77,4.9l0,.05c.22-.48.43-1,.66-1.44.79-1.63,1.42-3.31,2.35-4.87.06-.1-.09-.19-.14-.09-1,1.55-2.07,3-2.89,4.65-.39.77-.75,1.54-1.09,2.33-.19.43-.38.86-.55,1.3-.07.2-.17.42-.23.63-.56.76-1.11,1.53-1.64,2.31-1.19,1.72-2.25,3.54-3.45,5.25-.06.09.08.18.15.09,1.22-1.61,2.58-3.1,3.82-4.7s2.46-3.3,3.64-5,2.29-3.3,3.44-4.94a49.52,49.52,0,0,0,3.47-5.08A.06.06,0,0,0,234.37,317.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "227.236px 327.658px"
    },
    id: "elrlxm9n2vdnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.19,271.08c5.78,22.67,17.28,49.74,22,54.07,6,5.47,45,14.83,46.89,15,4.8.37,13.55-34.29,8.44-34.9-7.78-.94-36-1.79-37.74-3.49s-14-16.49-26.69-33.15C136.37,257.09,128.6,257,132.19,271.08Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "171.182px 300.189px"
    },
    id: "elo1h8pq01g9e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.21,338.38c.57.27,8.76,4.15,13.8,5.48,3.76,1,14.66,3.55,16.16-.47,1-2.75-5.2-5-9.57-6.71-2.3-.9-5.17-3.22-4.53-4.7,1.11-2.59,7-.16,11,2,7.57,4.16,17.69,11.72,22.16,7.83,1.69-1.47-.38-4-3.36-6.51,4.82,2.86,9.94,5.18,11.88,3.62,1.11-.89,1.14-2.08.47-3.41,1.48.44,2.77.32,3.65-.66,1.51-1.65.7-4-1.05-6.42a1.84,1.84,0,0,0,1.38-1c3.15-5.06-13.55-19-19.24-20.18-16.75-3.56-34.27-2.4-34.27-2.4C199.23,310.26,197.19,338.37,197.21,338.38Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "228.437px 325.125px"
    },
    id: "el9nmxs81h9en",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.32,322.46a28.3,28.3,0,0,1,11.2,4c4.29,2.69,7.17,5.88,10.79,9.08a.1.1,0,0,1-.13.15c-1.72-1.52-8.86-7.22-10.69-8.51a26.94,26.94,0,0,0-11.18-4.66C221.26,322.53,221.27,322.46,221.32,322.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "232.306px 329.083px"
    },
    id: "elqzmwby2mlx9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.25,315.33a67.48,67.48,0,0,1,13,4.16c4.5,2.16,8.06,5.77,11.57,9.24q3.15,3.12,6.17,6.39c.08.09,0,.24-.13.15q-5.34-5.38-11-10.43a35.65,35.65,0,0,0-12-7.15c-2.53-.89-5.12-1.59-7.7-2.29C224.19,315.39,224.2,315.31,224.25,315.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "239.591px 325.312px"
    },
    id: "elsryuy4kz43i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.78,309c4.27.77,8,1.43,11.81,3.61,5.06,2.9,10,7.87,11.72,9.63,1.91,1.94,3.76,4,5.57,6,.08.09-.06.22-.14.13a141.74,141.74,0,0,0-13.28-12.53,28.06,28.06,0,0,0-7.36-4.54,50.71,50.71,0,0,0-8.33-2.25S228.76,309,228.78,309Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "243.336px 318.7px"
    },
    id: "elb32osbup5bi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.93,303.54l-11,38s-32.46-8.43-38.5-14.65-17.71-38.76-21.29-54.59,4.47-15.62,12.1-5.77,26.62,33.71,27.66,34.21S202.93,303.54,202.93,303.54Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "167.097px 300.606px"
    },
    id: "elkv4s549bkfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.43,324.86c1.33-4.48,2.71-8.95,3.87-13.49.67-2.57,1.35-5.15,2-7.73,0-.09-.14-.15-.17-.05-1.52,4.44-3,8.91-4.35,13.42s-2.66,9-3.91,13.48c-.71,2.57-1.34,5.14-1.89,7.75,0,.05.07.08.09,0C185.73,333.87,187.08,329.37,188.43,324.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "189.14px 320.914px"
    },
    id: "elz8tk09pvzuj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.36,302.77a17.07,17.07,0,0,1-.25,2.57,14.81,14.81,0,0,1-3.36,6.91,11.33,11.33,0,0,1-4.11,3.12,16,16,0,0,1-5,1.24,27.76,27.76,0,0,1-4.37.09H172c-.17,0-.33,0-.5,0-1.71-.12-3.41-.31-5.11-.52a97.85,97.85,0,0,0-10.21-1.05,18.74,18.74,0,0,0-5.07.49,9.27,9.27,0,0,0-3.43,1.62l-.07-.15a9.49,9.49,0,0,1,3.46-1.63,19.09,19.09,0,0,1,5.11-.52,100.1,100.1,0,0,1,10.23,1c1.7.21,3.4.41,5.11.51l.75,0h.3a27.5,27.5,0,0,0,4.06-.11,15.69,15.69,0,0,0,4.92-1.24,10.83,10.83,0,0,0,4-3.05,15.8,15.8,0,0,0,2.6-4.36,14.8,14.8,0,0,0,.94-5,1.71,1.71,0,0,0,0-.32l.27,0C189.37,302.56,189.36,302.67,189.36,302.77Zm-10.19-1.12v-.06l-.25,0s0,.06,0,.09a19.13,19.13,0,0,1-.51,5.06,18.11,18.11,0,0,1-1.93,4.71,18.3,18.3,0,0,1-3.1,4.05c-.36.35-.74.68-1.14,1a2.78,2.78,0,0,1-.27.21,16,16,0,0,1-2.76,1.69,25.61,25.61,0,0,1-4.83,1.69c-3.3.84-6.73,1.33-9.92,2.66a16.15,16.15,0,0,0-3,1.6c0,.05.07.08.08.12a16.92,16.92,0,0,1,3-1.58c3.16-1.31,6.58-1.79,9.89-2.63a25.53,25.53,0,0,0,4.87-1.69,15,15,0,0,0,3-1.85,1.46,1.46,0,0,0,.28-.21c.34-.28.67-.57,1-.88a18.41,18.41,0,0,0,3.14-4.08,18.08,18.08,0,0,0,1.95-4.75A18.51,18.51,0,0,0,179.17,301.65Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "168.487px 313.03px"
    },
    id: "elanbyr8zpwnv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcunzvjdg7xs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193,337.77l-1.09,3.78s-32.47-8.44-38.52-14.64-17.7-38.77-21.28-54.6c-2.62-11.57,1-14.58,6.09-11.5C152,279.83,178.09,315.9,193,337.77Z",
    style: {
      opacity: 0.1,
      transformOrigin: "162.117px 300.614px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.92,345.89c.19.18,68.8-14.85,69.44-15.65.89-1.12-11.37-52.72-24.31-68.12-3.24-3.85-13.54-3.58-18.15.3C99.05,281.68,94.27,345.22,94.92,345.89Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "129.635px 302.629px"
    },
    id: "elz1o3lmn3aea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.26,266.31C102,277.26,64.54,321.5,72.37,332s61.56,7,77.24,2.49c4.66-1.35-7.3-31-12.28-32.48-4.14-1.23-27.4,5.09-27.82,3.74-.48-1.52,4.68-11.33,13-29.26C132.08,255.83,122.54,261.48,116.26,266.31Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "110.986px 300.322px"
    },
    id: "elld6edcquvkd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.24,296.86c10.75.28,13.47,2,22.66-2.59,6-3,10.54-.44,6.44,5.24-6.7,9.31-20.64,11.86-25.73,11.36Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "175.576px 301.966px"
    },
    id: "eluqzqnw964",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.67,302.36s12.88-4.6,24.37-5.44c7.94-.58,25.35.08,38.88,19.61,3.21,4.63,4.5,13.51-3.49,7.85-5.67-4-8.06-8.29-11.79-10,0,0,.3,11.49-4.46,14.52a103.27,103.27,0,0,1-13,7.05,20.81,20.81,0,0,1-1.54-2.32s-4.72,2.41-12.51.35Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "163.543px 316.372px"
    },
    id: "eluoe48ml5nu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.7,297.57c3.34,2.51,10.32,7.94,14.48,14.37,4.62,7.14,11.61,22.15,6.3,25.51-3.89,2.46-7.06-3-7.06-3s1.58,6.81-2.42,8.26c-3.65,1.33-5.85-3.07-5.85-3.07s.25,4.3-3.51,4.9c-4.52.73-4.3-8.4-9.51-11.62C154,332.17,162.7,297.57,162.7,297.57Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "170.207px 321.076px"
    },
    id: "elw3ip8fqu4wq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.82,315.57c2.75,2.87,7.32,11,7.68,18.69,0,.18-.11.28-.16.12a83.51,83.51,0,0,0-7.59-18.77S168.79,315.54,168.82,315.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "172.625px 325.011px"
    },
    id: "eltdgiwjwe5ap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.74,320.45c2.12,2.72,6.46,11.31,6.56,19.12,0,.17-.13.26-.17.1a89.45,89.45,0,0,0-6.45-19.18S161.72,320.41,161.74,320.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "164.99px 330.096px"
    },
    id: "elc3su3lcywq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.66,314.28c3.25,1.58,5.2,3.63,7.76,6.11a47.05,47.05,0,0,0,4,3.52c1.27,1,3.14,2.47,4.82,1.53a2.85,2.85,0,0,0,1.09-2.69,13.76,13.76,0,0,0-1.24-4.21c0-.05.06-.09.09,0a19.64,19.64,0,0,1,1.48,3.81,4.59,4.59,0,0,1-.13,2.72c-.81,1.81-3.08,1.69-4.57.91a15.85,15.85,0,0,1-2.48-1.75c-.75-.62-1.47-1.27-2.18-1.93-1.44-1.37-2.81-2.82-4.24-4.21a45.65,45.65,0,0,0-4.42-3.66A.07.07,0,0,1,178.66,314.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "187.69px 320.399px"
    },
    id: "eln50k9pcvbr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.83,327.51a107.7,107.7,0,0,0-5.26-13.16c0-.05.05-.1.09-.05,2.25,3,5.42,10.4,6.07,12.71s1.32,5.2.93,7.57c-.59,3.58-3.08,3.87-4,3.9a4.7,4.7,0,0,1-3-1,9.46,9.46,0,0,1-2.33-3.05c0-.05.05-.11.08-.05,1,1.61,2.84,3.34,4.83,3.41a3.28,3.28,0,0,0,2.41-.83,4.25,4.25,0,0,0,1-2.78A19.83,19.83,0,0,0,183.83,327.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.053px 326.38px"
    },
    id: "el2k8sm0nqnq2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.67,302.36l10.79,37.57s-67.17,3.83-70.89-8.37,28.73-52.16,42.19-63.13c15.6-12.72,16.43-7.38,11.36,5.34-5.32,13.32-14.48,32.34-14.48,32.34Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "105.868px 300.826px"
    },
    id: "elco10rvrlqqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.73,299.6a1.75,1.75,0,0,0-.11.24c-.4,0-.8,0-1.2,0a16,16,0,0,1-5-1.28,30,30,0,0,1-3.86-2l-.27-.16a4.06,4.06,0,0,1-.41-.25c-1.46-.91-2.86-1.89-4.26-2.9-1.62-1.16-3.23-2.36-4.88-3.5a.79.79,0,0,1,.12-.15c1.65,1.13,3.26,2.33,4.88,3.48,1.4,1,2.8,2,4.25,2.88.2.13.42.26.64.38a1.75,1.75,0,0,0,.27.16,27.36,27.36,0,0,0,3.61,1.86,15.88,15.88,0,0,0,4.92,1.23A11.29,11.29,0,0,0,112.73,299.6ZM122.62,270a16.27,16.27,0,0,0-1.46,2.15,27.1,27.1,0,0,0-2.06,4.72c-.57,1.62-1,3.27-1.6,4.88a32.73,32.73,0,0,1-1.94,4.74,19.18,19.18,0,0,1-2.86,4.21,17.69,17.69,0,0,1-3.94,3.22,18.1,18.1,0,0,1-4.64,2.09,11.32,11.32,0,0,1-1.49.32,1.35,1.35,0,0,1-.34.06,14.57,14.57,0,0,1-3.23.19,25.36,25.36,0,0,1-5-.82c-1.66-.42-3.31-.93-5-1.37a1.34,1.34,0,0,1-.11.14c1.68.46,3.34,1,5,1.4a24.27,24.27,0,0,0,5.08.83,15.86,15.86,0,0,0,3.51-.21,1.86,1.86,0,0,0,.34-.06,12.17,12.17,0,0,0,1.27-.29,18.37,18.37,0,0,0,4.7-2.1,17.86,17.86,0,0,0,4-3.26,19.23,19.23,0,0,0,2.91-4.24,35,35,0,0,0,2-4.76c.55-1.63,1-3.28,1.62-4.89a27,27,0,0,1,2-4.67,14.83,14.83,0,0,1,3.21-3.92,12,12,0,0,1,1.8-1.31c0-.14.06-.25.09-.37a14.26,14.26,0,0,0-2.06,1.47A15,15,0,0,0,122.62,270Zm6.12,32.71-.08,0a18.62,18.62,0,0,1,.14,2.25c0,.47,0,.93-.05,1.41,0,0,0,.11,0,.17a20.69,20.69,0,0,1-.59,3.49,18.53,18.53,0,0,1-1.93,4.72,16.64,16.64,0,0,1-3.23,4c-2.52,2.31-5.56,3.95-8.38,5.89a25,25,0,0,0-4,3.26,17,17,0,0,0-2.17,2.76l-.18.31a12.47,12.47,0,0,0-.61,1.14,18.4,18.4,0,0,0-1.54,4.92,18.64,18.64,0,0,0-.29,3.26h.22a19.48,19.48,0,0,1,.28-3.23,18.09,18.09,0,0,1,1.5-4.87,13,13,0,0,1,.73-1.32,1.6,1.6,0,0,1,.19-.29,15.82,15.82,0,0,1,2-2.55,25.6,25.6,0,0,1,3.94-3.25c2.82-1.94,5.87-3.57,8.4-5.92a17.29,17.29,0,0,0,3.24-4,18.65,18.65,0,0,0,1.93-4.77,20.21,20.21,0,0,0,.56-3.38c0-.06,0-.12,0-.17,0-.52.05-1,.05-1.55A19.41,19.41,0,0,0,128.74,302.7Zm4.2,12.85a13.16,13.16,0,0,0-1.59-4.88c-.75-1.44-1.64-2.78-2.5-4.14l-.1-.14a33.61,33.61,0,0,1-1.91-3.35h-.07a32.75,32.75,0,0,0,2,3.51l.09.14c.83,1.32,1.69,2.64,2.41,4a13.22,13.22,0,0,1,1.55,4.83,10.28,10.28,0,0,1-.79,5,9,9,0,0,1-3.26,3.83,19.06,19.06,0,0,1-4.59,2.21,101.72,101.72,0,0,1-9.93,2.54c-1.67.39-3.35.79-5,1.28l-.48.15-.3.08a31.16,31.16,0,0,0-4,1.58,15.89,15.89,0,0,0-4.25,2.91,11.18,11.18,0,0,0-2.79,4.33c0,.11-.08.21-.11.32l.27,0a1.38,1.38,0,0,1,.08-.27,11,11,0,0,1,2.72-4.24,15.59,15.59,0,0,1,4.18-2.86,27.1,27.1,0,0,1,3.77-1.49,1.11,1.11,0,0,1,.29-.1c.24-.09.48-.16.73-.23,1.63-.49,3.29-.9,5-1.29a97.66,97.66,0,0,0,10-2.57,19.45,19.45,0,0,0,4.63-2.25,9.16,9.16,0,0,0,3.31-3.9A10.56,10.56,0,0,0,132.94,315.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "110.98px 303.485px"
    },
    id: "ell8usduz24pj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.43,312.12a76.35,76.35,0,0,1,10.36-4,75,75,0,0,1,10.71-2.37c2.06-.32,4.14-.55,6.21-.78a.05.05,0,1,1,0,.1,95.51,95.51,0,0,0-10.8,2.27q-5.3,1.38-10.55,3c-2,.59-3.93,1.28-5.89,1.94A.07.07,0,1,1,88.43,312.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "102.064px 308.626px"
    },
    id: "elahvkuyblb34",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.51,302.23c-.34,0-19,2.95-19.64,3.12.11-.25,4.85-9.15,5.55-10.45l.21-.39c.42-.56.85-1.12,1.25-1.7.52-.74,1-1.48,1.54-2.23a0,0,0,0,0,0,0c-.54.72-1.09,1.43-1.62,2.16-.25.33-.49.67-.73,1,.47-.92.93-1.85,1.4-2.78.73-1.48,1.42-3,2.1-4.5,0-.05,0-.07-.08,0-1.39,2.59-2.86,5.14-4.27,7.72s-6.71,12.1-6.69,12.09,20.65-3.65,21-3.75A.13.13,0,0,0,130.51,302.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "120.098px 296.342px"
    },
    id: "elwj240kbukrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.94,325.15c-1.17-4.19-2.32-8.39-3.66-12.54-.75-2.35-1.5-4.71-2.28-7.06,0-.09-.19-.05-.16,0,1,4.25,2,8.51,3.25,12.72s2.38,8.37,3.64,12.54c.72,2.37,1.5,4.71,2.36,7,0,.05.1,0,.09,0C130.3,333.57,129.13,329.36,127.94,325.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "126.509px 321.664px"
    },
    id: "el09xguk4k8ukx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,340.61c-.47-1.18-1-2.86-1.55-4-.14-.3-.36-.28-.26,0,.33,1.06.56,2.22.88,3.3-.94,0-1.88,0-2.82.08l-3.25.14c-2.13.08-4.26.15-6.39.19q-6.47.12-12.93,0A248.53,248.53,0,0,1,90,338.47c-2.4-.31-4.8-.66-7.18-1.09a70.36,70.36,0,0,1-7-1.5.06.06,0,0,0,0,.11,40.62,40.62,0,0,0,6,1.81c2.14.46,4.3.87,6.46,1.2,4.32.66,8.66,1.1,13,1.41q12.94.94,25.94.78c2.43,0,4.85-.08,7.27-.16,1.22,0,2.45-.08,3.67-.15S142.28,340.81,142.2,340.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "108.993px 338.547px"
    },
    id: "ell1wfc21ead9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.51,
    y: 347.91,
    width: 79.32,
    height: 3.55,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "198.17px 349.685px"
    },
    id: "el00rs1ku6r3gim",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.83 347.91 237.83 351.47 183.91 351.47 186.63 347.91 237.83 347.91",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "210.87px 349.69px"
    },
    id: "elqsxqpjy5cp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.05 351.47 267.35 351.47 273.79 298.97 196.49 298.97 190.05 351.47",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "231.92px 325.22px"
    },
    id: "el1f65qm89qmd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.22,325.22a4.6,4.6,0,0,0,4.62,4.7,4.8,4.8,0,0,0,4.79-4.7,4.62,4.62,0,0,0-4.63-4.71A4.8,4.8,0,0,0,227.22,325.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "231.925px 325.215px"
    },
    id: "elfeh19bcywl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,274c-3.14,0-9.31-6.28-11.57-11.36-.15-.35.65-3.82,1.43-8.08.46-2.59.92-5.48,1.14-8.15l16.41,5.47A42.58,42.58,0,0,0,141.73,262a5.79,5.79,0,0,0,0,1.11,1.07,1.07,0,0,1,0,.18C141.93,265.4,141.72,274.08,136.8,274Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "134.711px 260.205px"
    },
    id: "elcjnr1wi4wo5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.75,263.11a.9.9,0,0,1,0,.18,10.37,10.37,0,0,1-1.74-.05c-9.5-1-10.86-12.81-11-16.43l15.22,5.07A43.11,43.11,0,0,0,141.73,262,6.7,6.7,0,0,0,141.75,263.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "136.62px 255.058px"
    },
    id: "eltietjbd7z5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.42,224.52c.94.21,3.73,7.9,3.1,11.17s-3.12,9.55-4.09,9.47S153.7,224.35,154.42,224.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "155.343px 234.84px"
    },
    id: "eli7b338an51",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,225.51c-3.1,5.4-3.86,22.88-.58,27.57,4.75,6.79,14.44,9.54,20.69,3.39,6.06-6,6.65-28.76,2.81-33.21C147.26,216.7,134.58,217.52,130,225.51Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "141.314px 239.381px"
    },
    id: "el0jiv7chvane8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.51,237.63a12.94,12.94,0,0,0,1.51-.41,2.54,2.54,0,0,0,1.46-.7.8.8,0,0,0-.06-1,2,2,0,0,0-2-.36,3,3,0,0,0-1.78,1.14A.86.86,0,0,0,141.51,237.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.559px 236.34px"
    },
    id: "elmy0bts0oidq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.38,238.63a15,15,0,0,1-1.47-.5,2.46,2.46,0,0,1-1.41-.81.78.78,0,0,1,.12-1,2,2,0,0,1,2-.23,3,3,0,0,1,1.71,1.25A.86.86,0,0,1,153.38,238.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "152.417px 237.291px"
    },
    id: "elwgp265rge58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.32,251.36c.26.29.51.69.94.76a3.13,3.13,0,0,0,1.28-.2s.08,0,.05.06a1.58,1.58,0,0,1-1.54.53,1.26,1.26,0,0,1-.85-1.11C141.19,251.33,141.28,251.31,141.32,251.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.398px 251.938px"
    },
    id: "elaebws247t5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.82,247.93a4,4,0,0,0,2.54,2,4.92,4.92,0,0,0,1.43.17.87.87,0,0,0,.28,0,1.23,1.23,0,0,0,.26,0,.28.28,0,0,0,.25-.24h0a.49.49,0,0,0,0-.12h0v-.1c.09-.91.11-2.29.11-2.29.32.19,1.94,1.08,2,.6a60.47,60.47,0,0,0-.64-12.23.11.11,0,0,0-.22,0c-.2,3.77.25,7.56.11,11.36a7.18,7.18,0,0,0-1.85-.72c-.13,0,0,2.67-.06,3.08a.16.16,0,0,1,0,0,5.57,5.57,0,0,1-4-1.6C142.85,247.76,142.76,247.83,142.82,247.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.282px 242.861px"
    },
    id: "elaieii2lvlyj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.29,249.59a4.75,4.75,0,0,1-2,1.33,2.14,2.14,0,0,1-1.3,0c-.92-.32-.88-1.18-.65-1.9a4.93,4.93,0,0,1,.5-1.1A6.2,6.2,0,0,0,146.29,249.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "144.246px 249.471px"
    },
    id: "elcnc38xp2e7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.28,250.92a2.14,2.14,0,0,1-1.3,0c-.92-.32-.88-1.18-.65-1.9A2.2,2.2,0,0,1,144.28,250.92Z",
    style: {
      fill: "rgb(255, 154, 187)",
      transformOrigin: "143.236px 250.021px"
    },
    id: "elljng3l8zpg9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,240.7s-.1,0-.1.09c-.09,1.17-.39,2.49-1.48,2.76,0,0,0,.07,0,.07C143.7,243.58,144.07,241.82,144,240.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "143.214px 242.16px"
    },
    id: "elvdoei984zxo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.06,239.37c-1.86-.34-2.41,3.4-.68,3.71S144.61,239.66,143.06,239.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.662px 241.223px"
    },
    id: "elygwj04zm7o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.77,241.23s.09.07.08.12c-.22,1.15-.27,2.5.72,3.05,0,0,0,.07,0,.06C150.3,244.09,150.39,242.29,150.77,241.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.046px 242.845px"
    },
    id: "elfqjwlmyvh0u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,240.18c1.89.15,1.46,3.9-.29,3.77S150.42,240.06,152,240.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.912px 242.065px"
    },
    id: "eltb9kyy3yba",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,241c3,.69,4.91-2.44,6.6-7,1-2.65,1-8.19,1-8.19s7.17,4.68,11.58,4.92,8.66-3,8.94-6.44c.25-3-4.16-7.46-10.62-8.66-4.5-.83-12.68,1.72-16.75,6.12,0,0-6.09,1.92-5.85,6.35S125.66,240.25,129,241Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "140.512px 228.285px"
    },
    id: "elcy5krph6e7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.29,240.73c3.84,1.4,6.77-4.27,7.31-7.36s-.22-6.65-.34-9.87c0,0,0,0,0,0,.8,4,1.56,9-.3,12.86-1.18,2.4-3.61,6.29-6.78,4.59C129.1,240.88,129.16,240.68,129.29,240.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "133.129px 232.434px"
    },
    id: "elhvs00nsgidv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.29,226.74c.93-2.57,4.33-4.76,7-5,0,0,0,0,0,0-3.19.67-7.21,3.68-6.75,7.22.37,2.83,1.18,6.59,2.73,9a.06.06,0,0,1-.1.06c-1.26-1.66-1.62-3.65-2.12-5.64C123.57,230.68,122.64,228.53,123.29,226.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "126.678px 229.889px"
    },
    id: "eld4zcgwplczd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.19,222.14c4.3-4.63,12.85-9.37,19.23-6.87a0,0,0,0,1,0,0c-6.86-2.06-14,3-19,7.08C129.24,222.5,129.06,222.27,129.19,222.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "138.783px 218.489px"
    },
    id: "el6bxs71zt7p2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.14,246.48a5.45,5.45,0,1,1,6.56-5.56h0a5.45,5.45,0,0,1-6.56,5.56Zm2.09-9.94a4.55,4.55,0,0,0-1.17-.1,4.73,4.73,0,1,0,1.17.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "141.255px 241.145px"
    },
    id: "eluhfcvdc066d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.34,247.88c-2-.53-3.31-3.07-2.91-5.89a6.48,6.48,0,0,1,1.66-3.61,3.63,3.63,0,0,1,3.11-1.22,3.58,3.58,0,0,1,2.64,2,6.44,6.44,0,0,1,.62,3.93c-.42,3-2.56,5.14-4.77,4.83Zm2-9.94-.28-.06a2.89,2.89,0,0,0-2.47,1,5.74,5.74,0,0,0-1.47,3.21c-.36,2.57.82,4.87,2.64,5.13s3.58-1.64,4-4.21a5.85,5.85,0,0,0-.54-3.49A3,3,0,0,0,154.37,237.94Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "153.449px 242.545px"
    },
    id: "el596jp1cjhh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.46,241.54l-.42-.6c.89-.62,2.88-1.37,4.07.16l-.57.45C148.47,240.17,146.54,241.48,146.46,241.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "148.075px 240.875px"
    },
    id: "elwh36wtdh4qh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.17,240.74l-.61-.39c.18-.29,1.83-2.8,3.47-2.92s11.17,1.69,11.58,1.77l-.13.71c-2.77-.51-10.21-1.83-11.4-1.75S122.61,240.05,122.17,240.74Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "129.085px 239.082px"
    },
    id: "elvl7zc4bg8y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.74,240.31s-2.69-6.24-5.44-5.39-1.53,9.34,1.15,11a3,3,0,0,0,4.29-.77Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "128.242px 240.673px"
    },
    id: "eluwxhdhi3nsq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.71,237.34a0,0,0,0,0,0,.08c1.87,1.24,2.55,3.35,2.89,5.47a1.67,1.67,0,0,0-2.35-1c-.06,0,0,.13,0,.13a1.84,1.84,0,0,1,1.86,1,8.91,8.91,0,0,1,.63,1.82c.05.2.4.17.38,0v-.05C130.71,242.23,129.44,238.18,126.71,237.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "128.486px 241.159px"
    },
    id: "elthgscx6ti59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.09,411.09c-.92,2.5-46.28,58.88-49.37,59.94-1.17.4-9.77-5.72-20-13.42-2.19-1.66-4.45-3.39-6.74-5.16-14.85-11.48-30.33-24-30.33-24l30.23-37.81,29.5,25,6.48,5.49s27-13.82,30.54-14.61S373,408.59,372.09,411.09Z",
    style: {
      fill: "rgb(247, 169, 160)",
      transformOrigin: "318.91px 430.844px"
    },
    id: "el18bmsgixahn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.09,411.09c-.92,2.5-46.28,58.88-49.37,59.94-1.43.49-13.82-8.66-26.69-18.58l29.4-36.77,6.48,5.49s27-13.82,30.54-14.61S373,408.59,372.09,411.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "334.1px 438.737px"
    },
    id: "elro2d00p492c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.09,411.09c-.92,2.5-46.28,58.88-49.37,59.94-1.17.4-9.77-5.72-20-13.42l29.14-36.44s27-13.82,30.54-14.61S373,408.59,372.09,411.09Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "337.445px 438.737px"
    },
    id: "el1asyrpk36yq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.19,410.08c-7.84,9.27-38.57,47.37-45.61,57.13-.06.08,0,.12.06,0,8-9,38.38-47.36,45.7-57C369.49,410,369.35,409.89,369.19,410.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "346.48px 438.634px"
    },
    id: "elgpi56jhupdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.5,408.55a9.77,9.77,0,0,0-2.24,7.51,9.41,9.41,0,0,0,3.35,6.17c.06,0,.14-.06.09-.11a11.24,11.24,0,0,1-1.08-13.47A.08.08,0,0,0,357.5,408.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "356.951px 415.382px"
    },
    id: "elavfs7sch3tm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.8,418.26c-3.09,3.74-5.29,9.2-4.08,14,0,.19.31.12.34,0a67.24,67.24,0,0,1,4.26-13.69A.31.31,0,0,0,335.8,418.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.859px 425.27px"
    },
    id: "elckzufmh6o9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.29,416.26c-3.1,3.74-5.29,9.2-4.09,14,.05.19.32.12.35,0a67.05,67.05,0,0,1,4.26-13.69A.31.31,0,0,0,339.29,416.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "337.346px 423.27px"
    },
    id: "el3xnbnvdv3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.78,414.25c-3.1,3.74-5.29,9.2-4.09,14,.05.19.31.12.35,0a67.44,67.44,0,0,1,4.26-13.69A.31.31,0,0,0,342.78,414.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "340.836px 421.26px"
    },
    id: "el8casuoj7a4a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27,412.25c-3.1,3.74-5.29,9.2-4.09,14,.05.19.31.12.34,0a67.05,67.05,0,0,1,4.26-13.69A.3.3,0,0,0,346.27,412.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "344.328px 419.249px"
    },
    id: "eltqv8phfjx6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.54,457.58c-3.4,4.25,3.2,9.55,6.61,5.28S320,453.32,316.54,457.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "319.849px 460.221px"
    },
    id: "elj7v4sksd1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,406.05c-3.13.64-3.52,4.3-2.82,6.81a25.5,25.5,0,0,0,6.91,11.22c.07.07.15,0,.2,0a.59.59,0,0,0,.85-.44c.31-4.19,1.15-8.63.16-12.79C333.72,408.39,332,405.45,329,406.05Zm4.3,11.11c-.1,2.07-.3,4.12-.32,6.18a75.8,75.8,0,0,1-3.89-6.64,28.59,28.59,0,0,1-1.44-3.43c-.59-1.83-.76-8.09,3.66-5.15C333.74,409.74,333.42,414.7,333.3,417.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "330.326px 415.057px"
    },
    id: "elcqtsvs8bwcu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,434.6c3.15-2.88,4.95-7,7.05-10.67a.59.59,0,0,0-.46-.84c0-.08,0-.16-.15-.14a25.45,25.45,0,0,0-12,5.41c-2,1.68-3.71,4.93-1.48,7.21S325.09,436.29,326.93,434.6Zm-4,.56c-5.31-.05-1.65-5.13-.14-6.32a27.78,27.78,0,0,1,3.12-2,74.88,74.88,0,0,1,6.95-3.31c-1.14,1.72-2.13,3.53-3.2,5.29C328.38,430.9,325.86,435.18,322.94,435.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "326.438px 429.83px"
    },
    id: "elrq8y6pkz279",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.85,410l-31.46,42.45L186.23,378.76,176,371.65s-2.9,2-7.26,4.36c-6.06,3.35-14.95,7.6-22.8,8.75-13.18,2-35.19,1.75-46.3-13.11-9.35-12.51-4.27-28.83-4.27-28.83l14.47-6.21s34.24-28.53,56.43-29.39c9.42-.38,23.14,6.76,35.85,14.22S323.85,410,323.85,410Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "208.921px 379.828px"
    },
    id: "elsibdv1djve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,371.65s-2.9,2-7.26,4.36c-7.72-9.23-24-26-24.55-26.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "160.095px 362.71px"
    },
    id: "ely3xo3sub5nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.38,327.06c-2,1.42-4,2.93-6,4.39s-4,2.78-5.93,4.35-3.74,3.3-5.55,5q-1.3,1.24-2.58,2.52A24.88,24.88,0,0,0,99.81,346c-.07.09.06.2.15.14a26.42,26.42,0,0,0,2.74-2.23c1-.8,1.91-1.62,2.86-2.43,1.84-1.57,3.72-3.09,5.55-4.66s3.52-3.26,5.33-4.84,4-3.27,6-4.87C122.46,327.09,122.42,327,122.38,327.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "111.118px 336.598px"
    },
    id: "el2jd3kyh2trz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.47,408.46c-2.05,2.2-3.94,4.57-5.84,6.9s-3.81,4.68-5.7,7c-3.77,4.72-7.57,9.41-11.28,14.17-2,2.62-4,5.26-5.94,8-.09.12.1.26.2.15,4.06-4.46,7.77-9.22,11.54-13.93s7.53-9.45,11.23-14.22c2-2.62,4.11-5.22,6-8C316.73,408.48,316.56,408.36,316.47,408.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "302.188px 426.571px"
    },
    id: "elzm2d1z8k6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.34,408.89c-5.28-4.16-10.76-8.09-16.24-12s-10.89-7.78-16.42-11.55c-1.59-1.08-3.19-2.14-4.79-3.2s-3.26-2-4.83-3.15c-.09-.06-.17.09-.08.15,1.44,1,2.79,2.19,4.21,3.26s2.68,2.05,4,3.06c2.65,2,5.33,3.89,8,5.82,5.42,3.92,10.88,7.8,16.4,11.58,3.14,2.15,6.26,4.31,9.46,6.35C229.29,409.33,229.52,409,229.34,408.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.172px 394.106px"
    },
    id: "elnwpp6mg5m1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.29,365.09c-4.88-4-10.11-7.68-15.23-11.42s-10.32-7.61-15.52-11.36l-15.46-11.18c-5-3.61-10-7.28-15.25-10.48-2.88-1.75-5.85-3.37-8.89-4.83a58.14,58.14,0,0,0-9.19-3.76.09.09,0,0,0-.07.16c2.61,1.45,5.34,2.68,8,4.08s5.16,2.84,7.69,4.37c5.23,3.18,10.18,6.78,15.15,10.36,10.32,7.42,20.62,14.87,31,22.19,5.82,4.1,11.52,8.42,17.56,12.19C263.25,365.52,263.46,365.23,263.29,365.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "223.499px 338.747px"
    },
    id: "el6z74jubneia",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-127",
    className: "animable",
    style: {
      transformOrigin: "410.603px 364.95px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.92,360.13s-9.14-14-29.58-11.29c-19.44,2.59-31.52,36.63-12.7,42.63s18.49-26.6,26-31.42C402.18,356.52,409.49,358.09,412.92,360.13Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "387.073px 370.348px"
    },
    id: "el2slk1vhfupd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.07,366.42a39.6,39.6,0,0,1,4.43-2.77,18.1,18.1,0,0,1,4.6-1.77,26.11,26.11,0,0,1,2.93-3.11,25.61,25.61,0,0,1,6.5-4.24c-.2,0-.39-.08-.59-.1a31,31,0,0,0-3.19-.27,17.87,17.87,0,0,0-6.32.95.09.09,0,0,1-.06-.18,28,28,0,0,1,6.34-1.27,17.45,17.45,0,0,1,3.15,0c.56.05,1.12.15,1.67.25l.32.06a27.23,27.23,0,0,1,6-1.58l-.54-.2a27.29,27.29,0,0,0-2.92-.77,23.25,23.25,0,0,0-6-.47c-.12,0-.14-.19,0-.19a38.47,38.47,0,0,1,6.07.32,25.5,25.5,0,0,1,5,1.13,28.34,28.34,0,0,1,3.69-.07c7,.37,14.37,3.7,18.12,9.84s3.87,13.88,4,20.88a155.5,155.5,0,0,1-2,29.16c-.1.57-.9.39-.86-.16.51-8.25,1-16.5,1-24.77,0-3.83,0-7.68-.32-11.5a33.63,33.63,0,0,0-1.87-9.62,17.16,17.16,0,0,0-6.07-7.9,23,23,0,0,0-9.28-3.85,26,26,0,0,0-9.06,0,5.94,5.94,0,0,1-.12,1.78,9.79,9.79,0,0,1-.64,2.14,11,11,0,0,1-1,1.87c-.43.65-.95,1.22-1.43,1.84-.08.09-.23,0-.15-.13a9,9,0,0,0,1.93-3.8,15.29,15.29,0,0,0,.43-2c.08-.52.08-1,.15-1.55a26.76,26.76,0,0,0-9.17,3.78c-.52.35-1,.71-1.53,1.09a10.14,10.14,0,0,1,1.5,2.25,20.33,20.33,0,0,1,1.48,3.34,26.94,26.94,0,0,1,1.19,7.13c0,.13-.19.14-.19,0a20.35,20.35,0,0,0-1.65-6.81,26.83,26.83,0,0,0-1.5-3.1c-.29-.51-.6-1-.92-1.52-.17-.27-.36-.54-.52-.82a27.65,27.65,0,0,0-6.43,7.45l0,0a14,14,0,0,1,2,3.59,31.15,31.15,0,0,1,1.49,4.19,68.1,68.1,0,0,1,1.62,8.38c0,.12-.18.14-.19,0a34.55,34.55,0,0,0-2.08-8.31c-.48-1.31-1-2.6-1.54-3.88a33.74,33.74,0,0,1-1.55-3.68,25.72,25.72,0,0,0-3.16,9.05.1.1,0,0,1-.19,0,32.44,32.44,0,0,1,5.84-13.8c-1.28.4-2.55.79-3.79,1.31a21.22,21.22,0,0,0-4.44,2.53C366.09,366.66,366,366.5,366.07,366.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "392.684px 381.558px"
    },
    id: "elqxr38kimxb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.68,368.55c.41,2,1,4,1.34,6.07a23,23,0,0,1,.33,6c0,.05-.1.05-.1,0a57.28,57.28,0,0,0-1.76-12A.1.1,0,1,1,380.68,368.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.45px 374.571px"
    },
    id: "el8m12aj7r3k5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.47,362.45a11.12,11.12,0,0,1,2.83-1.64,19.11,19.11,0,0,1,3.17-.8c.12,0,.14.18,0,.2a11.76,11.76,0,0,0-3.06.93,23.26,23.26,0,0,0-2.88,1.41A.06.06,0,1,1,368.47,362.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.498px 361.289px"
    },
    id: "elpz1x8mc1xi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,343.86s-1.93-23.52-19.41-31.14c-14.6-6.37-22.95,10-12.63,20.08C379.34,340.92,392.72,337.26,403,343.86Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "384.687px 327.574px"
    },
    id: "el7b8ix8k75ol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.22,317.27A73.54,73.54,0,0,1,382,321a58,58,0,0,1,6,4c-.29-.59-.54-1.22-.83-1.8-.46-.9-.95-1.79-1.49-2.65a24.94,24.94,0,0,0-3.85-4.88c-.09-.08.05-.22.14-.13a38.78,38.78,0,0,1,4.05,4.72,26.91,26.91,0,0,1,1.66,2.66,10.56,10.56,0,0,1,1.18,2.71l.19.14a56.58,56.58,0,0,1,8.35,8.17c-.05-.24-.1-.47-.16-.68-.32-1.15-.68-2.28-1.06-3.42a29.14,29.14,0,0,0-3.15-6.85c-.07-.11.1-.2.16-.1a53.57,53.57,0,0,1,3.66,6.69,25.6,25.6,0,0,1,1.21,3.48,14.82,14.82,0,0,1,.57,2.36c.76,1,1.51,1.94,2.22,2.94,7.5,10.69,11.27,23.61,12.17,36.54a111.87,111.87,0,0,1,.2,11.58,71.82,71.82,0,0,1-1,11.63c-.05.24-.43.17-.42-.07.09-3.4.44-6.78.5-10.18a99.41,99.41,0,0,0-.33-10.21,94.68,94.68,0,0,0-3.81-20,71.4,71.4,0,0,0-8.89-18.81c-.73-.14-1.46-.34-2.19-.53s-1.74-.45-2.61-.69a26.42,26.42,0,0,1-4.88-1.79c-.11,0,0-.23.1-.16a15.71,15.71,0,0,0,4.95,1.7c1.36.28,2.79.45,4.16.77a64.24,64.24,0,0,0-4.07-5.34,30.24,30.24,0,0,1-9.94-.75,39,39,0,0,1-5.09-1.58c-1.76-.68-3.41-1.54-5.14-2.27a.09.09,0,1,1,.08-.17,29.24,29.24,0,0,0,10.08,3.3,62.16,62.16,0,0,0,9.43.78c-1.24-1.42-2.52-2.81-3.89-4.12-4.59-4.37-10.05-8.39-16.1-10.48C374.05,317.42,374.11,317.23,374.22,317.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "393.694px 356.885px"
    },
    id: "el82j77x6qdgw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.45,317.35a26.62,26.62,0,0,1,2.14,3.13,17.23,17.23,0,0,1,1.54,3.65s-.05.06-.07,0c-.58-1.15-1.08-2.35-1.67-3.49a17.24,17.24,0,0,0-2.08-3.18C388.23,317.38,388.37,317.25,388.45,317.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "390.208px 320.735px"
    },
    id: "elnrrctdyl8eh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.19,325.17a17.84,17.84,0,0,0,3.58,1.5,32.9,32.9,0,0,0,3.66,1c.05,0,0,.11,0,.1a17.36,17.36,0,0,1-3.78-.83,30.3,30.3,0,0,1-3.54-1.58C372,325.28,372.08,325.11,372.19,325.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.755px 326.464px"
    },
    id: "elbhrgyl15drv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.65,340.39c.11,1,2.64-8.54,17.43-17,13.42-7.7,29.44-27.74,16.28-40.39C438.74,272.76,410.75,295,415.65,340.39Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "434.673px 310.502px"
    },
    id: "elajj4ie4x0i7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.48,395.16a261.55,261.55,0,0,1,2.34-29.72,133.53,133.53,0,0,1,6.25-26.61c1.1-3.1,2.35-6.16,3.72-9.17a19.65,19.65,0,0,1,.06-3.52c.07-1.51.2-3,.34-4.51s.29-3,.47-4.5.5-3,.56-4.48a.1.1,0,1,1,.19,0,31.52,31.52,0,0,0-.53,4.76c-.11,1.45-.2,2.9-.24,4.35s0,2.91,0,4.37c0,.52,0,1.08,0,1.64q2.09-4.41,4.49-8.65c-1-6.13.3-12.53,1.55-18.52a.09.09,0,0,1,.18.05,52.24,52.24,0,0,0-1,9.5c-.06,2.52.06,5,.07,7.55.36-.6.71-1.21,1.07-1.8,1.92-3.13,4-6.2,6.14-9.18a14.49,14.49,0,0,1,.15-4.36,32.67,32.67,0,0,1,1.07-4.78q.71-2.34,1.63-4.61c.64-1.55,1.5-3,2.11-4.58.06-.13.25-.05.18.07a22.69,22.69,0,0,0-1.85,4.64,41,41,0,0,0-1.21,4.6c-.31,1.56-.57,3.11-.79,4.69-.14,1-.24,2.11-.41,3.17a112.2,112.2,0,0,1,10.35-12c.08-.09.21,0,.13.14a136.09,136.09,0,0,0-15,20.44L427,315c.82-.51,1.75-.92,2.52-1.35l4.31-2.36q2.1-1.14,4.19-2.29c.71-.4,1.42-.81,2.15-1.19a16.45,16.45,0,0,0,2.5-1.39c.12-.08.24.09.12.16-1.42.78-2.68,1.94-4.06,2.82s-2.78,1.73-4.22,2.53c-2.62,1.46-5.48,2.52-8.06,4-1.8,3.14-3.45,6.36-5,9.64,1.57-1,3.17-2,4.8-2.87,1.05-.59,2.1-1.17,3.16-1.73a15.55,15.55,0,0,0,3-1.8c.09-.08.22.06.13.14a27.62,27.62,0,0,1-5.68,3.95c-1.9,1.11-3.81,2.19-5.79,3.15q-2.37,5.21-4.28,10.58c-6.22,17.62-8.5,36.32-9.6,54.89-.32,5.54-.49,11.07-.56,16.62s.22,11.07.21,16.6c0,.17-.27.21-.29,0-.66-4.91-.78-9.91-1-14.85S405.36,400.19,405.48,395.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "424.113px 356.783px"
    },
    id: "eljpm96qtj8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.33,315.4a70.21,70.21,0,0,0,7.85-4.06,83.79,83.79,0,0,0,7.46-4.73s.09,0,.05.07a61.16,61.16,0,0,1-7.16,5,69.38,69.38,0,0,1-8.11,3.89C432.31,315.62,432.22,315.45,432.33,315.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "439.99px 311.095px"
    },
    id: "elxp0nxosauj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.05,295.49c.22-.86.49-1.7.78-2.54a.08.08,0,0,1,0-.1c.19-.48.38-1,.58-1.42a.54.54,0,0,1,.07-.17c0-.09.07-.18.11-.27s.06,0,.05,0-.1.33-.15.49a1.38,1.38,0,0,1-.08.27,70.19,70.19,0,0,0-2.19,10c0,.1-.18.11-.17,0A33.68,33.68,0,0,1,428.05,295.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "428.346px 296.389px"
    },
    id: "elj6r6hakstsc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,365.85c5.15-16,16.8-25.5,31.76-23.3S464.8,364.45,454.8,371s-22.82-6.65-28.92-8.88S413,365.85,413,365.85Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "436.491px 357.521px"
    },
    id: "el94swnfxzhu9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.63,406.7c-.22-1.81-.41-3.62-.6-5.44q-.58-5.43-1.16-10.86c-.7-6.62-.91-13.19.95-19.65a29.93,29.93,0,0,1,9.66-15,24.38,24.38,0,0,1,5.69-3.49,14.43,14.43,0,0,1,6.53-4.9,29.22,29.22,0,0,1,10.07-1.69c.12,0,.15.18,0,.19a24.51,24.51,0,0,0-9.46,2A20.27,20.27,0,0,0,429.7,350a16.85,16.85,0,0,0-2,1.73,20.86,20.86,0,0,1,8.79-1.17,19.22,19.22,0,0,1,3.19.57,8.88,8.88,0,0,1,2.36-.54,14,14,0,0,1,3.17,0,23.62,23.62,0,0,1,6.28,1.73.1.1,0,0,1-.08.18,22.16,22.16,0,0,0-6.07-1.35,19.16,19.16,0,0,0-3,0,13.43,13.43,0,0,0-1.65.25,19.26,19.26,0,0,1,10.61,7.92c.07.11-.09.22-.15.12a17.65,17.65,0,0,0-13.19-7.8c-.33,0-.66,0-1-.05a13,13,0,0,1,.36,1.43c.2.71.43,1.42.68,2.12a37.19,37.19,0,0,0,1.79,4.21,33.26,33.26,0,0,0,2.35,4,20.28,20.28,0,0,0,3,3.76.1.1,0,1,1-.14.13c-1-1.23-2.23-2.33-3.22-3.62a31,31,0,0,1-2.54-3.9,27.63,27.63,0,0,1-1.92-4.31c-.28-.78-.52-1.58-.73-2.38a5.65,5.65,0,0,1-.3-1.47,19.72,19.72,0,0,0-5.12.62c1.15,3.48,2.37,7.1,4.81,9.92.08.09-.08.22-.15.12a42.11,42.11,0,0,1-3.2-4.76,19.37,19.37,0,0,1-2-5.14,23.81,23.81,0,0,0-8,4,28.16,28.16,0,0,0-9.47,13.88,46.56,46.56,0,0,0-1.65,18.19c.61,7.72,1.61,15.43,1.93,23.17,0,.5-.74.78-.92.23A26.47,26.47,0,0,1,411.63,406.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "430.449px 378.88px"
    },
    id: "elqdplwrbdlqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.34,354.44a8.66,8.66,0,0,1,1.44-1.76c.53-.58,1.07-1.15,1.65-1.67a13.65,13.65,0,0,1,3.86-2.51.1.1,0,0,1,.08.18,10.85,10.85,0,0,0-3.8,2.59c-.55.53-1.06,1.09-1.56,1.67a11.05,11.05,0,0,1-1.47,1.66A.14.14,0,0,1,421.34,354.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "424.875px 351.556px"
    },
    id: "el22eac8qrzuc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.36,356.55a46.13,46.13,0,0,1,4,3.94,27.08,27.08,0,0,1,3.18,4.57c0,.05-.05.09-.08.05a60.13,60.13,0,0,0-7.19-8.41C445.15,356.62,445.27,356.47,445.36,356.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "448.88px 360.827px"
    },
    id: "elkk25sp89ahb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.48,357.3a10.56,10.56,0,0,0,1.21,2.59,17.54,17.54,0,0,0,1.73,2.21s0,.11-.08.07a9.9,9.9,0,0,1-3-4.79C429.27,357.26,429.44,357.19,429.48,357.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "430.872px 359.712px"
    },
    id: "eljzqav5em7bd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.86 398.73 390.91 411.23 394.14 449.36 428.73 449.36 431.96 411.23 433.01 398.73 389.86 398.73",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "411.435px 424.045px"
    },
    id: "el82jsqfo1yi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.86 398.73 390.91 411.23 431.96 411.23 433.01 398.73 389.86 398.73",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "411.435px 404.98px"
    },
    id: "eldwurhac0256",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgpsbvuahi46"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.46,
    y: 393.71,
    width: 49.94,
    height: 11.99,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "411.43px 399.705px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefinition);
export default __webpack_public_path__ + "static/media/definition.0a148c32ce35bb888d6b65bf299a7560.svg";
export { ForwardRef as ReactComponent };